/* ==========================================================================
   Stylist Virtuale Armonia — assets/stylist.js  (fase 3.2, spec v3.2)
   - Motore (pure functions, testabile in Node) + UI (solo nel browser)
   - Dati: Storefront API (GraphQL), un caricamento per occasione, filtri locali
   - Stato nell'URL: ?occ=sera&col=verde | pal=1 &c=top,pantalone&tt=42&ts=40&b=150&seed=123
   - Colore: la cliente sceglie UN colore protagonista oppure una palette di stagione;
     lo stylist abbina con una tabella di abbinamenti e la regola 60/30/10 per ruolo.
   - Nessun evento verso Klaviyo/Meta/GA4 qui (fasi 4-5): la pagina emette solo
     CustomEvent "stylist:<nome>" su document; il consenso lo gestisce chi li ascolta.
   ========================================================================== */
(function (root) {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 1. DEFAULT (tutto sovrascrivibile dalle impostazioni della sezione)
   * ------------------------------------------------------------------ */
  var DEFAULTS = {
    collection: 'stylist',
    apiVersion: '2025-07',
    seasonTag: 'A/I26',
    excludedTags: ['outlet60%', "'-60%", 'blackfriday20', 'blackfriday30', '2025',
      'primavera/estate25', 'autunno/inverno', 'primavera/estate'],
    minRatio: 0.6,            // il look deve arrivare ad almeno il 60% del tetto (preferenza)
    freeShipping: 60,         // soglia spedizione gratuita (contesto-negozio.md)
    minBrandCount: 3,         // filtro brand: mostra solo brand con >= N capi
    tries: 160,
    minSizeCount: 1,          // taglie: mostra una taglia se ha almeno N capi
    minPieceCount: 2,         // passaggio 3: un capo è attivo solo se ci sono >= N capi
    minColorCount: 2,         // passaggio 2: un colore compare solo se ha >= N capi
    maxPieces: 5,             // slot massimi in un look (capospalla, top, sotto, scarpe, borsa)
    pageSize: 100,
    occasions: [
      { k: 'daily', l: 'Tutti i giorni', d: 'Casual e comodi' },
      { k: 'ufficio', l: 'Ufficio', d: 'Curati e professionali' },
      { k: 'sera', l: 'Serata', d: 'Per uscire' },
      { k: 'cerimonia', l: 'Cerimonia', d: 'Eventi speciali' }
    ],
    /* tag occ: letti per ogni occasione (occ:weekend = Tutti i giorni) */
    occTags: { daily: ['daily', 'weekend'] },
    /* famiglie colore: quello che vede la cliente */
    families: [
      { k: 'nero', l: 'Nero', hex: '#211C1D' }, { k: 'bianco', l: 'Bianco e panna', hex: '#F3EEE4' },
      { k: 'beige', l: 'Beige e cammello', hex: '#CDB596' }, { k: 'marrone', l: 'Marrone', hex: '#6B4632' },
      { k: 'grigio', l: 'Grigio', hex: '#8E8A8B' }, { k: 'blu', l: 'Blu e denim', hex: '#2F4A78' },
      { k: 'rosso', l: 'Rosso e bordeaux', hex: '#7A1F2B' }, { k: 'verde', l: 'Verde', hex: '#5B6B3A' },
      { k: 'rosa', l: 'Rosa e viola', hex: '#D9A0B4' }, { k: 'giallo', l: 'Giallo e arancio', hex: '#D9A23A' },
      { k: 'fantasia', l: 'Fantasia', hex: '#CFC4BB' }
    ],
    /* neutri: possono fare da base (60%). Il denim conta come neutro. */
    neutrals: ['nero', 'bianco', 'beige', 'marrone', 'grigio', 'oro', 'argento'],
    metals: ['oro', 'argento'],          // solo come accento (borsa, accessori)
    /* abbinamenti: colore protagonista => colori con cui può stare nello stesso look */
    pairs: {
      nero: ['bianco', 'grigio', 'beige', 'rosso', 'rosa'],
      bianco: ['nero', 'blu', 'beige', 'marrone', 'verde', 'rosso', 'rosa'],
      beige: ['marrone', 'bianco', 'nero', 'blu', 'verde', 'rosso'],
      marrone: ['beige', 'bianco', 'blu', 'nero', 'verde', 'rosso', 'rosa', 'giallo'],
      grigio: ['rosa', 'bianco', 'nero', 'rosso', 'blu'],
      blu: ['bianco', 'beige', 'grigio', 'marrone', 'rosso', 'giallo'],
      rosso: ['nero', 'beige', 'marrone', 'grigio', 'blu', 'bianco', 'rosa'],
      verde: ['bianco', 'beige', 'marrone', 'rosso', 'giallo'],
      rosa: ['grigio', 'bianco', 'marrone', 'rosso', 'blu'],
      giallo: ['marrone', 'blu', 'verde', 'bianco', 'grigio'],
      fantasia: ['nero', 'bianco', 'beige', 'marrone']
    },
    /* palette di stagione (sovrascritte dai blocchi della sezione) */
    palettes: [
      { name: 'Cioccolato e crema', desc: 'Marroni caldi su base panna, il colore chiave dell’inverno.', cols: ['marrone', 'beige', 'bianco'], push: '' },
      { name: 'Bordeaux e denim', desc: 'Il rosso vino delle passerelle con blu e panna.', cols: ['rosso', 'blu', 'bianco'], push: '' },
      { name: 'Oliva e cioccolato', desc: 'Verde oliva e marrone, il duo più autunnale.', cols: ['verde', 'marrone', 'bianco'], push: '' }
    ],
    budgetBands: [
      { max: 200, l: 'Fino a €200' }, { max: 300, l: '€200 – 300' }, { max: 0, l: 'Nessun limite' }
    ],
    unica: [40, 42, 44],      // taglia unica = S, M, L = IT 40, 42, 44 (spec 3.4)
    directMin: 34,            // numeri >= 34 nei valori taglia = taglia italiana diretta
    /* --- colore: token (handle/label del metafield, senza suffisso -NN) => famiglia --- */
    colorMap: {
      panna: 'bianco', ecru: 'bianco', avorio: 'bianco', latte: 'bianco', 'off-white': 'bianco', crema: 'bianco',
      burro: 'beige', naturale: 'beige', sand: 'beige', sabbia: 'beige', nude: 'beige', champagne: 'beige',
      cammello: 'beige', taupe: 'beige', vaniglia: 'beige', corda: 'beige', kaki: 'beige', khaki: 'beige',
      moro: 'marrone', tabacco: 'marrone', fondente: 'marrone', cioccolato: 'marrone', caramello: 'marrone',
      fango: 'marrone', cuoio: 'marrone', cognac: 'marrone', mocha: 'marrone', toffee: 'marrone',
      grigi: 'grigio', antracite: 'grigio', piombo: 'grigio', perla: 'grigio',
      'blu-navy': 'blu', navy: 'blu', azzurro: 'blu', cielo: 'blu', celeste: 'blu', 'celeste-chiaro': 'blu',
      petrolio: 'blu', cobalto: 'blu', avion: 'blu', denim: 'blu',
      bordeaux: 'rosso', vino: 'rosso', ciliegia: 'rosso', mattone: 'rosso',
      'verde-militare': 'verde', 'verde-salvia': 'verde', 'verde-acqua': 'verde', oliva: 'verde', militare: 'verde', salvia: 'verde', bosco: 'verde',
      cipria: 'rosa', rosato: 'rosa', 'rosa-fluo': 'rosa', fucsia: 'rosa', lilla: 'rosa', malva: 'rosa',
      porpora: 'rosa', ciclamino: 'rosa', viola: 'rosa', lavanda: 'rosa', prugna: 'rosa',
      arancione: 'giallo', arancio: 'giallo', senape: 'giallo', ocra: 'giallo', ruggine: 'giallo', zucca: 'giallo', terracotta: 'giallo',
      oro: 'oro', gold: 'oro', 'gold-rose': 'oro', argento: 'argento', silver: 'argento'
    },
    denimTokens: ['denim', 'denim-medio', 'denim-chiaro', 'blue-denim', 'rinse'],
    fantasiaTokens: ['fantasia', 'animale', 'animalier', 'zebrato', 'righe', 'floreale', 'scacchi', 'multicolore',
      'arcobaleno', 'principe-di-galles', 'stampa', 'leopardato', 'pois', 'pied-de-poule'],
    /* --- ruolo dal percorso categoria: [regex, ruolo]; 'fuori' = mai; 'title' = dal titolo --- */
    roleRules: [
      ['lingerie|bikini|abbigliamento sportivo|leggings|joggers|pantaloni da camera|abbigliamento da notte|reggiseni|calzetteria|mutande', 'fuori'],
      ['tailleur', 'title'],
      ['outfit|monopezzi|completi$', 'abito'],
      ['abiti$', 'abito'],
      ['gonne', 'gonna'],
      ['pantaloncini|pantaloni|jeans', 'pantalone'],
      ['cappotti e giacche|gilet|kimono', 'capospalla'],
      ['indumenti superiori|body', 'top'],
      ['borse da spiaggia', 'fuori'],
      ['borsette|borse|bagagli', 'borsa'],
      ['scarpe', 'scarpe'],
      ['collane|orecchini|cinture', 'accessorio']
    ],
    /* --- taglie: da guide brand, in taglie italiane (spec 3.4) --- */
    sizeTables: {
      letters: {
        std: { XS: [38], S: [40], M: [42], L: [44] },
        jjxx: { XS: [34], S: [36], M: [38], L: [40, 42], XL: [44] },
        tensionein: { XS: [38, 40], S: [40, 42], M: [42, 44], L: [44, 46], XL: [46, 48] },
        liujo: { XS: [38, 40], S: [40, 42], M: [42, 44], L: [44, 46], XL: [48] }
      },
      waist: {
        liujo: { 25: [38], 26: [40], 27: [40], 28: [42], 29: [42], 30: [44], 31: [44], 32: [46] },
        jjxx: { 25: [34], 26: [34, 36], 27: [36], 28: [38], 29: [38], 30: [40, 42], 31: [40, 42], 32: [40, 42, 44] }
      },
      brands: {
        vicolo: { letters: 'std' },
        abbigliamentoarmonia: { letters: 'std', waist: 'liujo' },
        susymix: { letters: 'std' },
        jjxx: { letters: 'jjxx', waist: 'jjxx' },
        tensionein: { letters: 'tensionein' },
        liujo: { letters: 'liujo', waist: 'liujo' },
        haveone: { letters: 'std' }, lumina: { letters: 'std' }, dixie: { letters: 'std' },
        apparent: { letters: 'std' }, saiph: { letters: 'std' }, veromoda: { letters: 'std' }, civico1: { letters: 'std' }
      }
    },
    brandNames: {
      vicolo: 'Vicolo', jjxx: 'JJXX', liujo: 'Liu Jo', tensionein: 'Tensione In', susymix: 'Susy Mix',
      abbigliamentoarmonia: 'Armonia', haveone: 'Haveone', lumina: 'Lumina', dixie: 'Dixie',
      apparent: 'Appar_Ent', saiph: 'Saiph', veromoda: 'Vero Moda', civico1: 'Civico 1',
      divinefollie: 'Divine Follie', mefui: 'Me Fui', ovye: 'Ovyè', notinotte: 'Noi di notte', lemilli: 'Le Milli'
    },
    texts: { }
  };

  var PIECES = ['top', 'pantalone', 'gonna', 'abito', 'capospalla', 'scarpe', 'borsa'];   // selezionabili nel passaggio 3
  var BASE_PIECES = ['top', 'pantalone', 'gonna', 'abito'];          // la base del look (abito, oppure top + pantalone/gonna)
  var EXTRA_PIECES = ['capospalla', 'scarpe', 'borsa'];              // si aggiungono a qualsiasi base
  var CLOTH = { top: 1, pantalone: 1, gonna: 1, abito: 1, capospalla: 1 };
  var BASE_ROLES = { abito: 1, pantalone: 1, gonna: 1 };                // capi "base" (60%)
  var U_ROLES = { borsa: 1, accessorio: 1 };
  var ROLE_LABEL = { abito: 'Abito', pantalone: 'Pantalone', gonna: 'Gonna', top: 'Top',
    capospalla: 'Capospalla', scarpe: 'Scarpe', borsa: 'Borsa', accessorio: 'Accessorio' };
  /* chiave taglie per ruolo (pantalone e gonna condividono la riga "sotto") */
  var SZ_KEY = { top: 'top', pantalone: 'sotto', gonna: 'sotto', abito: 'abito', capospalla: 'capospalla', scarpe: 'scarpe' };

  /* ------------------------------------------------------------------ *
   * 2. UTILITÀ
   * ------------------------------------------------------------------ */
  function ascii(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* vecchi browser */ }
    return s.trim();
  }
  function brandKey(v) { return ascii(v).replace(/[^a-z0-9]/g, ''); }
  function slugToken(s) { return ascii(s).replace(/\s+/g, '-').replace(/-\d+$/, ''); }
  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function hash36(str) {
    var h = 5381; for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  function hashNum(s) { return parseInt(hash36(s), 36) || 0; }
  function numId(gid) { return String(gid).split('/').pop().split('?')[0]; }
  function mergeCfg(base, over) {
    var out = {}, k;
    for (k in base) out[k] = base[k];
    for (k in (over || {})) if (over[k] !== undefined && over[k] !== null && over[k] !== '') out[k] = over[k];
    return out;
  }
  function compileRules(rules) {
    return rules.map(function (r) { return [new RegExp(r[0], 'i'), r[1]]; });
  }
  function uniq(a) { var o = []; a.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; }
  function occTagsOf(occ, cfg) { return ((cfg.occTags && cfg.occTags[occ]) || [occ]).map(function (o) { return 'occ:' + o; }); }

  /* ------------------------------------------------------------------ *
   * 3. NORMALIZZAZIONE PRODOTTI (Storefront -> unità colore+taglia)
   * ------------------------------------------------------------------ */
  function roleFromTitle(title) {
    var t = ascii(title);
    if (/^completo\b/.test(t)) return 'abito';
    if (/giacca|blazer|giacchino|giubbino/.test(t)) return 'capospalla';
    if (/pantalon|pantaloni/.test(t)) return 'pantalone';
    if (/gonna/.test(t)) return 'gonna';
    return null;
  }
  function categoryPath(node) {
    var c = node.category, parts = [];
    if (c) {
      (c.ancestors || []).forEach(function (a) { if (a && a.name) parts.push(a.name); });
      if (c.name) parts.push(c.name);
    }
    var p = parts.join(' > ');
    return p || node.productType || '';
  }
  function resolveRole(node, cfg) {
    if (/^completo\b/i.test(ascii(node.title))) return 'abito';
    var path = ascii(categoryPath(node));
    if (!path) return { none: 'categoria mancante' };
    var rules = cfg._rules || (cfg._rules = compileRules(cfg.roleRules));
    for (var i = 0; i < rules.length; i++) {
      if (rules[i][0].test(path)) {
        var r = rules[i][1];
        if (r === 'fuori') return { none: 'categoria esclusa (' + path.split(' > ').pop() + ')' };
        if (r === 'title') { var tr = roleFromTitle(node.title); return tr || { none: 'tailleur: ruolo non ricavabile dal titolo' }; }
        return r;
      }
    }
    return { none: 'categoria non utilizzabile (' + (path.split(' > ').pop() || 'vuota') + ')' };
  }

  /* nome colore del catalogo -> famiglia. Prova il nome intero, poi accorcia da destra ("grigio-melange" -> "grigio"). */
  function colorInfo(rawToken, cfg) {
    var tok = slugToken(rawToken);
    if (!tok) return null;
    var map = cfg.colorMap, fams = cfg._famKeys || (cfg._famKeys = cfg.families.map(function (p) { return p.k; }));
    var isDenim = cfg.denimTokens.indexOf(tok) >= 0 || /denim/.test(tok);
    var isFant = cfg.fantasiaTokens.indexOf(tok) >= 0;
    var base = null, probe = tok;
    if (isFant) return { token: tok, base: 'fantasia', neutral: false, fantasia: true, classified: true };
    if (isDenim) return { token: tok, base: 'blu', neutral: true, fantasia: false, classified: true, denim: true };
    while (probe) {
      if (map[probe]) { base = map[probe]; break; }
      if (fams.indexOf(probe) >= 0) { base = probe; break; }
      var cut = probe.lastIndexOf('-');
      if (cut < 0) break;
      probe = probe.slice(0, cut);
    }
    if (!base) {
      /* ultimo tentativo: una parola nota dentro il nome ("maglia-verde-bosco") */
      var parts = tok.split('-');
      for (var i = 0; i < parts.length && !base; i++) {
        if (map[parts[i]]) base = map[parts[i]]; else if (fams.indexOf(parts[i]) >= 0) base = parts[i];
      }
    }
    if (!base) return { token: tok, base: null, neutral: false, fantasia: false, classified: false };
    if (base === 'fantasia') return { token: tok, base: 'fantasia', neutral: false, fantasia: true, classified: true };
    return { token: tok, base: base, neutral: cfg.neutrals.indexOf(base) >= 0, fantasia: false, classified: true,
      metal: cfg.metals.indexOf(base) >= 0 };
  }

  /* Taglia grezza (label o handle) -> array di taglie italiane */
  var LETTER_WORDS = [[/extra-?\s*small/g, 'xs'], [/extra-?\s*large/g, 'xl'], [/\bsmall\b/g, 's'],
    [/\bmedium\b/g, 'm'], [/\blarge\b/g, 'l']];
  function itSizes(brand, raw, cfg) {
    var T = cfg.sizeTables, bcfg = T.brands[brand];
    if (!bcfg) return null; // brand senza tabella
    var s = ascii(raw).replace(/[()]/g, ' ').replace(/[_/]/g, '-');
    if (/taglia[-\s]*unica|^unica$|^tu$|^one[-\s]*size$/.test(s)) return cfg.unica.slice();
    var flat = s.replace(/-/g, ' ');
    LETTER_WORDS.forEach(function (w) { flat = flat.replace(w[0], w[1]); });
    var toks = flat.split(/\s+/).filter(Boolean);
    var letters = [], bad = false;
    toks.forEach(function (t) {
      if (t === 'xs' || t === 's' || t === 'm' || t === 'l' || t === 'xl') { if (letters.indexOf(t) < 0) letters.push(t); }
      else if (/^(xxs|xxxs|xxl|xxxl|2xl|3xl)$/.test(t)) bad = true;
    });
    if (letters.length) {
      var tab = T.letters[bcfg.letters], out = [];
      letters.forEach(function (l) { (tab[l.toUpperCase()] || []).forEach(function (n) { if (out.indexOf(n) < 0) out.push(n); }); });
      return out;
    }
    if (bad) return [];
    var nums = (s.match(/\d+/g) || []).map(Number).filter(function (n) { return n >= 20; });
    if (!nums.length) return [];
    var n0 = nums[0];
    if (n0 >= cfg.directMin) return (n0 % 2 === 0 && n0 <= 48) ? [n0] : [];
    var wt = bcfg.waist && T.waist[bcfg.waist];
    if (!wt) return [];
    var waists = [n0]; if (nums[1] && nums[1] - n0 === 1) waists.push(nums[1]);
    var res = [];
    waists.forEach(function (w) { (wt[w] || []).forEach(function (n) { if (res.indexOf(n) < 0) res.push(n); }); });
    return res;
  }
  function shoeNumber(raw) {
    var m = String(raw).match(/\d{2}/); if (!m) return null;
    var n = parseInt(m[0], 10); return (n >= 34 && n <= 44) ? String(n) : null;
  }

  function moneyOf(x) { return x && x.amount != null ? parseFloat(x.amount) : null; }

  /* nodes = prodotti Storefront. Ritorna { units, excluded } */
  function normalize(nodes, cfg, occ) {
    var units = [], excluded = [], parent = {};
    function find(x) { while (parent[x] && parent[x] !== x) { parent[x] = parent[parent[x]] || parent[x]; x = parent[x]; } return x; }
    function union(a, b) { a = find(a); b = find(b); if (a !== b) parent[b] = a; }
    var seasonTag = ascii(cfg.seasonTag), excl = cfg.excludedTags.map(ascii);
    var occT = occ ? occTagsOf(occ, cfg) : null;

    nodes.forEach(function (n) {
      var why = function (r) { excluded.push({ title: n.title, handle: n.handle, brand: n.vendor, reason: r }); };
      var tags = (n.tags || []).map(ascii);
      if (occT && !occT.some(function (t) { return tags.indexOf(t) >= 0; })) return why('occasione (tag ' + occT.join(' o ') + ' mancante)');
      if (seasonTag && tags.indexOf(seasonTag) < 0) return why('stagione (manca ' + cfg.seasonTag + ')');
      for (var i = 0; i < excl.length; i++) if (tags.indexOf(excl[i]) >= 0) return why('stagione/outlet (tag ' + excl[i] + ')');
      var role = resolveRole(n, cfg);
      if (typeof role !== 'string') return why(role.none);
      var bk = brandKey(n.vendor);
      if (!cfg.sizeTables.brands[bk] && !U_ROLES[role] && role !== 'scarpe') return why('brand senza tabella taglie (' + n.vendor + ')');

      // modelli (varianti colore collegate)
      var refs = ((n.models && n.models.references && n.models.references.nodes) || []).map(function (r) { return r && r.handle; }).filter(Boolean);
      parent[n.handle] = parent[n.handle] || n.handle;
      refs.forEach(function (h) { parent[h] = parent[h] || h; union(n.handle, h); });

      // colore prodotto (metafield di categoria)
      var mfNodes = (n.colorMf && n.colorMf.references && n.colorMf.references.nodes) || [];
      var mfToks = mfNodes.map(function (m) {
        var lab = null;
        (m.fields || []).forEach(function (f) { if (f.key === 'label' && f.value) lab = f.value; });
        return { label: lab, handle: m.handle };
      });
      var variants = (n.variants && n.variants.nodes) || [];
      var colorOptName = /^(colore|color)$/i;
      var groups = {}, order = [];
      variants.forEach(function (v) {
        var opts = v.selectedOptions || [], colorTok = null, sizeRaw = null;
        opts.forEach(function (o) {
          if (colorOptName.test(o.name.trim())) colorTok = o.value;
          else if (/^(taglia|dimensione|size|numero di scarpa)/i.test(o.name.trim())) sizeRaw = o.value;
        });
        var key = colorTok != null ? ascii(colorTok) : '_prodotto';
        if (!groups[key]) { groups[key] = { raw: colorTok, vs: [] }; order.push(key); }
        groups[key].vs.push({ v: v, sizeRaw: sizeRaw });
      });

      var made = 0, reasons = {};
      order.forEach(function (key) {
        var g = groups[key], info = null, note = null;
        if (g.raw != null) info = colorInfo(g.raw, cfg);
        else if (mfToks.length === 1) info = colorInfo(mfToks[0].label || mfToks[0].handle, cfg);
        else if (mfToks.length > 1) note = 'colore: più colori nel metafield';
        else note = 'colore mancante (metafield categoria vuoto)';
        if (info && !info.classified && mfToks.length === 1 && g.raw == null) {
          var alt = colorInfo(mfToks[0].handle, cfg); if (alt && alt.classified) info = alt;
        }
        if (!info) { info = { token: 'nd', base: null, neutral: false, fantasia: false, classified: false }; note = note || 'colore mancante'; }
        else if (!info.classified) note = 'colore non classificato (' + info.token + ')';
        if (note) reasons[note] = 1;

        var unit = { uid: n.id + '|' + info.token, pid: n.id, handle: n.handle, title: n.title, brand: null, brandKey: bk,
          role: role, tags: tags, color: info, bySize: {}, sizeKeys: [], models: refs, img: null, hasStock: false, unmapped: false };
        unit.brand = cfg.brandNames[bk] || n.vendor;
        g.vs.forEach(function (e) {
          var v = e.v;
          if (!v.availableForSale) return;
          unit.hasStock = true;
          var rec = { gid: v.id, id: numId(v.id), price: moneyOf(v.price), compare: moneyOf(v.compareAtPrice),
            img: (v.image && v.image.url) || (n.featuredImage && n.featuredImage.url) || null, sizeLabel: e.sizeRaw };
          var keys;
          if (U_ROLES[role]) keys = ['U'];
          else if (role === 'scarpe') { var sn = shoeNumber(e.sizeRaw || ''); keys = sn ? [sn] : []; }
          else if (e.sizeRaw == null) keys = [];
          else { keys = (itSizes(bk, e.sizeRaw, cfg) || []).map(String); }
          if (e.sizeRaw != null && /taglia[-\s]*unica|^unica$/.test(ascii(e.sizeRaw)) && !U_ROLES[role] && role !== 'scarpe') keys.push('TU');
          if (!keys.length) { unit.unmapped = true; return; }
          keys.forEach(function (k) { if (!unit.bySize[k]) unit.bySize[k] = rec; });
        });
        unit.sizeKeys = Object.keys(unit.bySize);
        unit.img = (unit.sizeKeys.length && unit.bySize[unit.sizeKeys[0]].img) || (n.featuredImage && n.featuredImage.url) || null;
        if (!unit.hasStock) { reasons['esaurito'] = 1; return; }
        if (!unit.sizeKeys.length) { reasons['taglia non mappata'] = 1; return; }
        if (!info.classified) return;            // senza colore: mai nei look né nella griglia
        units.push(unit); made++;
      });
      if (!made) why(Object.keys(reasons).join('; ') || 'nessuna variante utilizzabile');
      else Object.keys(reasons).forEach(function (r) { if (/colore/.test(r)) excluded.push({ title: n.title, handle: n.handle, brand: n.vendor, reason: r + ' (alcune varianti escluse)' }); });
    });

    units.forEach(function (u) {
      var group = [u.handle].concat(u.models).map(find);
      u.model = group[0];
    });
    units.sort(function (a, b) { return a.uid < b.uid ? -1 : 1; });
    return { units: units, excluded: excluded };
  }

  /* ------------------------------------------------------------------ *
   * 4. MOTORE
   * ------------------------------------------------------------------ */

  /* --- regola colore della ricerca ---
     sel.col = famiglia protagonista  -> ammessi: protagonista + abbinamenti
     sel.pal = indice palette         -> ammessi: i colori della palette            */
  function colorRule(sel, cfg) {
    if (sel.pal != null && cfg.palettes[sel.pal]) {
      var p = cfg.palettes[sel.pal];
      return { mode: 'pal', prot: null, allowed: p.cols.slice(), push: ascii(p.push || ''), name: p.name, idx: sel.pal };
    }
    if (sel.col) return { mode: 'p', prot: sel.col, allowed: uniq([sel.col].concat((cfg.pairs && cfg.pairs[sel.col]) || [])), push: '' };
    return { mode: 'none', prot: null, allowed: [], push: '' };
  }
  function isNeutral(c) { return !!(c.neutral || c.denim); }

  /* --- 60/30/10: il peso di un capo nel look dipende dal ruolo e dagli altri capi ---
     60 = base: abito, pantalone, gonna (il capospalla se non c'è una base)
     30 = complemento: top, capospalla sopra una base (il top se c'è un capospalla-base)
     10 = accento: borsa, scarpe, cintura, cappello, bijoux                          */
  function levelOf(role, roles) {
    if (BASE_ROLES[role]) return 60;
    var hasBase = roles.some(function (r) { return BASE_ROLES[r]; });
    if (role === 'capospalla') return hasBase ? 30 : 60;
    if (role === 'top') return (hasBase || roles.indexOf('capospalla') >= 0) ? 30 : 60;
    return 10;
  }
  function newState() { return { fams: [], nn: [], fant: false }; }
  function stAdd(st, u) {
    var c = u.color;
    if (c.metal) return;
    if (st.fams.indexOf(c.base) < 0) st.fams.push(c.base);
    if (c.fantasia) st.fant = true;
    else if (!isNeutral(c) && st.nn.indexOf(c.base) < 0) st.nn.push(c.base);
  }
  function stateOf(pcs, skip) {
    var st = newState();
    pcs.forEach(function (p, i) { if (i !== skip) stAdd(st, p.u); });
    return st;
  }
  /* il colore di un capo va bene al suo livello, dati i capi già scelti?
     - solo colori ammessi (protagonista + abbinamenti, o palette); metalli solo come accento
     - la base (60) è il protagonista o un neutro: il colore forte sta nel 30 o nel 10
     - massimo 3 colori nel look, di cui massimo 2 non neutri; la fantasia solo con neutri */
  function colorFits(u, lvl, rule, st) {
    var c = u.color;
    if (!c.classified) return false;
    if (c.metal) return lvl === 10;
    if (rule.allowed.indexOf(c.base) < 0) return false;
    if (rule.mode === 'p' && lvl === 60 && c.base !== rule.prot && !isNeutral(c)) return false;
    var newFam = st.fams.indexOf(c.base) < 0;
    if (newFam && st.fams.length >= 3) return false;
    if (c.fantasia) return st.nn.length === 0 && !st.fant;
    if (!isNeutral(c)) {
      if (st.fant) return false;
      if (st.nn.indexOf(c.base) < 0 && st.nn.length >= 2) return false;
    }
    return true;
  }

  /* composizione: capi scelti -> modelli di look */
  function lookName(req) {
    if (req.indexOf('abito') >= 0) return 'Look con abito';
    if (req.indexOf('pantalone') >= 0) return 'Look con pantalone';
    if (req.indexOf('gonna') >= 0) return 'Look con gonna';
    if (req.indexOf('top') >= 0) return 'Look con top';
    if (req.indexOf('capospalla') >= 0) return 'Look con capospalla';
    return 'Scarpe e borsa';
  }
  function templatesFor(pieces) {
    var has = function (p) { return pieces.indexOf(p) >= 0; };
    var capo = EXTRA_PIECES.filter(has), out = [];
    var bottoms = ['pantalone', 'gonna'].filter(has);
    if (has('top') || bottoms.length) {
      (bottoms.length ? bottoms : [null]).forEach(function (b) {
        var req = []; if (has('top')) req.push('top'); if (b) req.push(b);
        req = req.concat(capo);
        out.push({ k: req.join('+'), name: lookName(req), req: req });
      });
    }
    if (has('abito')) { var ra = ['abito'].concat(capo); out.push({ k: ra.join('+'), name: lookName(ra), req: ra }); }
    if (!out.length && capo.length) out.push({ k: capo.join('+'), name: lookName(capo), req: capo });
    return out;
  }
  /* il look si indossa in una volta: abito OPPURE top + pantalone/gonna (pantalone e gonna si escludono).
     Capospalla, scarpe e borsa si aggiungono a qualsiasi base. Minimo 2 capi. */
  function compatible(pieces, add) {
    var out = pieces.filter(function (p) {
      if (add === 'abito') return p !== 'top' && p !== 'pantalone' && p !== 'gonna';
      if (add === 'top') return p !== 'abito';
      if (add === 'pantalone') return p !== 'abito' && p !== 'gonna';
      if (add === 'gonna') return p !== 'abito' && p !== 'pantalone';
      return true;
    });
    if (out.indexOf(add) < 0) out.push(add);
    return PIECES.filter(function (p) { return out.indexOf(p) >= 0; });
  }
  /* almeno 2 capi che si indossano insieme: lo stylist vende look, non capi singoli.
     Le esclusioni (abito / top, pantalone / gonna) le applica compatible() alla scelta */
  function hasLook(pieces) {
    var has = function (p) { return pieces.indexOf(p) >= 0; };
    if (pieces.length < 2) return false;
    if (has('pantalone') && has('gonna')) return false;
    if (has('abito') && (has('top') || has('pantalone') || has('gonna'))) return false;
    return true;
  }
  /* ruoli su cui deve stare il colore protagonista: i capi da 60 o 30; se il look ha solo accessori, uno di loro */
  function protRolesOf(req) {
    var big = req.filter(function (r) { return levelOf(r, req) >= 30; });
    return big.length ? big : req.slice();
  }
  /* un solo capo per modello di look = niente look, solo la griglia dei capi (non più raggiungibile dal passaggio 3) */
  function isGridMode(pieces) {
    var t = templatesFor(pieces);
    return !t.length || t.every(function (x) { return x.req.length === 1; });
  }
  /* taglie dedotte per i capi suggeriti che la cliente non ha scelto */
  function suggestSizes(sizes) {
    var out = [], tu = false;
    ['top', 'sotto', 'abito', 'capospalla'].forEach(function (k) {
      ((sizes && sizes[k]) || []).forEach(function (s) { if (s === 'TU') tu = true; else if (out.indexOf(s) < 0) out.push(s); });
    });
    if (tu) ['40', '42', '44'].forEach(function (s) { if (out.indexOf(s) < 0) out.push(s); });
    return out.sort();
  }

  function makeCtx(units, sel, cfg) {
    var sizes = sel.sizes || {}, pieces = sel.pieces || [];
    var rule = colorRule(sel, cfg);
    var ctx = { cfg: cfg, units: units, rule: rule, pieces: pieces, T: sel.budget || 0, brand: sel.brand || '*' };
    ctx.min = ctx.T ? ctx.T * cfg.minRatio : 0;
    var guess = suggestSizes(sizes);
    ctx.sz = {};
    ['top', 'pantalone', 'gonna', 'abito', 'capospalla'].forEach(function (r) {
      var own = sizes[SZ_KEY[r]] || [];
      ctx.sz[r] = (pieces.indexOf(r) >= 0 && own.length) ? own : (own.length ? own : guess);
    });
    ctx.sz.borsa = ['U'];
    ctx.sz.scarpe = sizes.scarpe || [];            // numero di scarpe: solo se scelto, mai dedotto dalle taglie
    ctx.pools = {};
    Object.keys(ctx.sz).forEach(function (r) { ctx.pools[r] = []; });
    units.forEach(function (u) {
      var want = ctx.sz[u.role]; if (!want || !want.length) return;
      var key = null;
      for (var i = 0; i < want.length; i++) { if (u.bySize[want[i]]) { key = want[i]; break; } }
      if (!key) return;
      var v = u.bySize[key];
      if (!v || v.price == null) return;
      if (ctx.T && v.price > ctx.T) return;
      if (ctx.brand !== '*' && u.brandKey !== ctx.brand) return;
      var c = u.color;
      if (!(c.metal ? !CLOTH[u.role] : rule.allowed.indexOf(c.base) >= 0)) return;
      ctx.pools[u.role].push({ u: u, v: v, sk: key, prot: rule.prot === c.base, push: !!(rule.push && u.tags.indexOf(rule.push) >= 0) });
    });
    return ctx;
  }
  /* scelta casuale con preferenza per i capi da spingere (tag della palette) */
  function pickFrom(cand, rand) {
    if (!cand.length) return null;
    var pushed = cand.filter(function (e) { return e.push; });
    var src = (pushed.length && rand() < 0.65) ? pushed : cand;
    return src[Math.floor(rand() * src.length)];
  }
  /* i capi scelti sono obbligatori; il protagonista sta su un capo da 60 o 30;
     preferenze (primi 75% dei tentativi): budget almeno al 60% del tetto, palette con almeno 2 colori */
  function tryLook(tpl, ctx, rand, usedBase) {
    var req = tpl.req, rule = ctx.rule, q;
    for (q = 0; q < req.length; q++) if (!ctx.pools[req[q]].length) return null;
    var big = protRolesOf(req);
    for (var t = 0; t < ctx.cfg.tries; t++) {
      var soft = t < ctx.cfg.tries * 0.75;
      var protRole = rule.mode === 'p' && big.length ? big[Math.floor(rand() * big.length)] : null;
      var order = protRole ? [protRole].concat(req.filter(function (r) { return r !== protRole; })) : req.slice();
      var pcs = [], st = newState(), models = {}, tot = 0, ok = true;
      for (q = 0; q < order.length; q++) {
        var r = order[q], lvl = levelOf(r, req);
        var cand = ctx.pools[r].filter(function (e) {
          if (models[e.u.model] || (lvl === 60 && usedBase[e.u.model])) return false;
          if (r === protRole && !e.prot) return false;
          if (ctx.T && tot + e.v.price > ctx.T) return false;
          return colorFits(e.u, lvl, rule, st);
        });
        var e = pickFrom(cand, rand);
        if (!e) { ok = false; break; }
        pcs.push({ role: r, u: e.u, v: e.v, sk: e.sk }); stAdd(st, e.u); models[e.u.model] = 1; tot += e.v.price;
      }
      if (!ok) continue;
      if (soft && ctx.min && tot < ctx.min) continue;
      if (soft && rule.mode === 'pal' && req.length > 1 && st.fams.length < 2) continue;
      pcs.sort(function (a, b) { return req.indexOf(a.role) - req.indexOf(b.role); });
      return { tpl: tpl, pcs: pcs, total: tot };
    }
    return null;
  }
  function lookId(look, sel) {
    return (sel.occ || 'x') + '-' + (sel.seed || 0) + '-' + hash36(look.pcs.map(function (p) { return p.v.id; }).join('.'));
  }
  function finishLook(look, sel) {
    look.id = lookId(look, sel);
    look.total = look.pcs.reduce(function (a, p) { return a + p.v.price; }, 0);
    look.swap = {};
    return look;
  }
  /* "Completa il look": capospalla (se non scelto) e borsa, nei colori ammessi, dentro il tetto, mai aggiunti da soli */
  function suggestions(look, ctx) {
    var out = [], max = ctx.cfg.maxPieces;
    if (look.pcs.length >= max) return out;
    var have = {}, used = {}, tot = 0, roles = look.pcs.map(function (p) { return p.role; });
    look.pcs.forEach(function (p) { have[p.role] = 1; used[p.u.model] = 1; tot += p.v.price; });
    var st = stateOf(look.pcs, -1);
    ['capospalla', 'borsa'].forEach(function (r) {
      if (have[r] || look.pcs.length + out.length >= max) return;
      var lvl = levelOf(r, roles.concat(r));
      var cand = (ctx.pools[r] || []).filter(function (e) {
        if (used[e.u.model]) return false;
        if (ctx.T && tot + e.v.price > ctx.T) return false;
        return colorFits(e.u, lvl, ctx.rule, st);
      });
      if (!cand.length) return;
      cand.sort(function (a, b) {
        return ((b.push ? 1 : 0) - (a.push ? 1 : 0)) || (hashNum((look.id || '') + a.u.uid) - hashNum((look.id || '') + b.u.uid));
      });
      out.push({ role: r, u: cand[0].u, v: cand[0].v, sk: cand[0].sk });
      stAdd(st, cand[0].u); tot += cand[0].v.price;
    });
    return out;
  }
  function buildLooks(units, sel, cfg, seed) {
    var ctx = makeCtx(units, sel, cfg), rand = mulberry32(seed || 1), usedBase = {}, looks = [];
    if (ctx.rule.mode === 'none' || isGridMode(ctx.pieces)) return { looks: [], ctx: ctx, grid: true };
    var tpls = templatesFor(ctx.pieces).filter(function (t) { return t.req.length > 1; });
    var rot = (seed || 0) % tpls.length, order = tpls.slice(rot).concat(tpls.slice(0, rot));
    var progress = true, guard = 0, selx = { occ: sel.occ, seed: seed };
    while (looks.length < 3 && progress && guard++ < 6) {
      progress = false;
      for (var i = 0; i < order.length && looks.length < 3; i++) {
        var l = tryLook(order[i], ctx, rand, usedBase);
        if (l) {
          l.pcs.forEach(function (p) { if (levelOf(p.role, order[i].req) === 60) usedBase[p.u.model] = 1; });
          looks.push(finishLook(l, selx)); progress = true;
        }
      }
    }
    looks.forEach(function (l) { l.sug = suggestions(l, ctx); });
    return { looks: looks, ctx: ctx, grid: false };
  }
  /* alternative per un pezzo di un look: stesso modello (altro colore) -> stesso colore -> resto */
  function alternatives(look, i, ctx, banned) {
    var cur = look.pcs[i], others = look.pcs.filter(function (_, k) { return k !== i; });
    var roles = look.pcs.map(function (p) { return p.role; }), lvl = levelOf(cur.role, roles);
    var tot = others.reduce(function (a, p) { return a + p.v.price; }, 0);
    var st = stateOf(look.pcs, i), used = {};
    others.forEach(function (p) { used[p.u.model] = 1; });
    var rule = ctx.rule, pr = protRolesOf(roles), protElsewhere = rule.mode !== 'p' || others.some(function (p) { return p.u.color.base === rule.prot && pr.indexOf(p.role) >= 0; });
    var list = (ctx.pools[cur.role] || []).filter(function (e) {
      if (e.u.uid === cur.u.uid) return false;
      if (banned && banned[e.v.gid]) return false;
      if (used[e.u.model]) return false;
      if (!protElsewhere && pr.indexOf(cur.role) >= 0 && !e.prot) return false;   // il protagonista non può sparire
      if (!colorFits(e.u, lvl, rule, st)) return false;
      if (ctx.T && tot + e.v.price > ctx.T) return false;
      return true;
    });
    var score = function (e) {
      var s = Math.abs(e.v.price - cur.v.price);
      if (e.u.model === cur.u.model) s -= 100000;
      else if (e.u.color.base === cur.u.color.base) s -= 50000;
      return s;
    };
    list.sort(function (a, b) { return score(a) - score(b) || (a.u.uid < b.u.uid ? -1 : 1); });
    return list;
  }
  /* "Tutti i capi": capi scelti nei colori ammessi, uno per colore (non raggruppati per modello),
     un prodotto per modello; prima i capi da spingere, poi il protagonista, poi per prezzo */
  function allItems(units, sel, cfg) {
    var ctx = makeCtx(units, sel, cfg), byModel = {}, order = [], grid = isGridMode(ctx.pieces), rule = ctx.rule;
    ctx.pieces.forEach(function (role) {
      var lvl = levelOf(role, ctx.pieces);
      (ctx.pools[role] || []).forEach(function (e) {
        if (e.u.color.metal) return;
        /* colore protagonista: con un capo solo si vedono solo capi del protagonista (gli abbinamenti stanno sotto ogni capo);
           con i look, sui capi base (60) solo protagonista o neutri */
        if (rule.mode === 'p' && !e.prot && (grid || (lvl === 60 && !isNeutral(e.u.color)))) return;
        var it = { u: e.u, v: e.v, role: role, sk: e.sk, prot: e.prot, push: e.push };
        var k = e.u.uid + '|' + role;          // un capo per colore: ogni colore è un prodotto a sé (struttura del catalogo)
        if (!byModel[k]) { byModel[k] = { first: it, others: [] }; order.push(k); }
        else byModel[k].others.push(it);
      });
    });
    var out = order.map(function (k) { return byModel[k]; });
    out.sort(function (a, b) {
      return ((b.first.push ? 1 : 0) - (a.first.push ? 1 : 0)) || ((b.first.prot ? 1 : 0) - (a.first.prot ? 1 : 0)) ||
        (a.first.v.price - b.first.v.price) || (a.first.u.uid < b.first.u.uid ? -1 : 1);
    });
    return { items: out, ctx: ctx };
  }
  /* griglia (un capo solo): fino a 2 abbinamenti per capo, con le stesse regole colore dei look */
  var COMPLETE_WITH = { top: [['pantalone', 'gonna'], ['capospalla']], pantalone: [['top'], ['capospalla']], gonna: [['top'], ['capospalla']],
    abito: [['capospalla'], ['borsa']], capospalla: [['top'], ['pantalone', 'gonna']] };
  function gridSuggest(item, ctx) {
    var groups = COMPLETE_WITH[item.role] || [], pcs = [{ role: item.role, u: item.u, v: item.v }], out = [];
    var used = {}; used[item.u.model] = 1;
    groups.forEach(function (g) {
      var best = null;
      g.forEach(function (r) {
        var roles = pcs.map(function (p) { return p.role; }).concat(r), st = stateOf(pcs, -1), lvl = levelOf(r, roles);
        var baseLvl = levelOf(item.role, roles);
        if (ctx.rule.mode === 'p' && !item.prot && baseLvl === 60 && !isNeutral(item.u.color)) return;  // il capo resta base: niente abbinamento
        (ctx.pools[r] || []).forEach(function (e) {
          if (used[e.u.model] || !colorFits(e.u, lvl, ctx.rule, st)) return;
          var sc = (e.push ? 2 : 0) + (e.u.color.base !== item.u.color.base ? 1 : 0) + (hashNum(item.u.uid + e.u.uid) % 1000) / 1000;   // meglio un contrasto che il tono su tono
          if (!best || sc > best.sc) best = { sc: sc, role: r, u: e.u, v: e.v, sk: e.sk };
        });
      });
      if (best) { out.push(best); pcs.push({ role: best.role, u: best.u, v: best.v }); used[best.u.model] = 1; }
    });
    return out;
  }
  /* passaggio 2: capi disponibili per famiglia (modelli distinti nei capi da look) */
  function familyCounts(units) {
    var seen = {}, out = {};
    units.forEach(function (u) {
      if (!CLOTH[u.role] || !u.color.classified || u.color.metal) return;
      var k = u.model + '|' + u.role + '|' + u.color.base;
      if (seen[k]) return; seen[k] = 1;
      out[u.color.base] = (out[u.color.base] || 0) + 1;
    });
    return out;
  }
  /* quanti capi entrano in gioco con una scelta colore */
  function countForColor(units, sel, cfg) {
    var rule = colorRule(sel, cfg), seen = {};
    units.forEach(function (u) {
      if (!CLOTH[u.role] || !u.color.classified || u.color.metal) return;
      if (rule.allowed.indexOf(u.color.base) >= 0) seen[u.model + '|' + u.role] = 1;
    });
    return Object.keys(seen).length;
  }
  /* passaggi 3 e 4: capi e taglie reali per i ruoli dati, nei colori ammessi */
  function pieceStats(units, roles, sel, cfg) {
    var rule = colorRule(sel, cfg), seen = {}, per = {}, n = 0;
    units.forEach(function (u) {
      if (roles.indexOf(u.role) < 0 || !u.color.classified) return;
      if (u.color.metal ? CLOTH[u.role] : rule.allowed.indexOf(u.color.base) < 0) return;
      var k0 = u.model + '|' + u.role;
      if (!seen[k0]) { seen[k0] = 1; n++; }
      u.sizeKeys.forEach(function (k) { (per[k] = per[k] || {})[k0] = 1; });
    });
    var counts = {};
    Object.keys(per).forEach(function (k) { counts[k] = Object.keys(per[k]).length; });
    return { n: n, counts: counts };
  }
  function sizeOptions(stats, cfg) {
    var min = cfg.minSizeCount, ks = Object.keys(stats.counts).filter(function (k) { return /^\d+$/.test(k); }).sort(function (a, b) { return a - b; });
    var good = ks.filter(function (k) { return stats.counts[k] >= min; }), relaxed = false;
    if (!good.length) { good = ks.slice(); relaxed = true; }
    var tuN = stats.counts.TU || 0;
    return { sizes: good, tu: tuN >= (relaxed ? 1 : min) };
  }
  function cloneSel(sel) {
    return { occ: sel.occ, col: sel.col, pal: sel.pal, pieces: sel.pieces.slice(), sizes: sel.sizes, budget: sel.budget, brand: '*' };
  }
  /* quando non esce nessun look: cosa cambiare per sbloccarne */
  function hints(units, sel, cfg) {
    var out = [], tries = [];
    if (sel.budget) tries.push({ label: 'Nessun limite di budget', patch: { budget: 0 } });
    EXTRA_PIECES.forEach(function (x) {
      if (sel.pieces.indexOf(x) < 0) return;
      var rest = sel.pieces.filter(function (p) { return p !== x; });
      if (hasLook(rest)) tries.push({ label: 'Senza ' + ROLE_LABEL[x].toLowerCase(), patch: { drop: x } });
    });
    (cfg.palettes || []).forEach(function (p, i) { if (sel.pal !== i) tries.push({ label: 'Palette «' + p.name + '»', patch: { pal: i } }); });
    tries.forEach(function (t) {
      var s = cloneSel(sel);
      if (t.patch.budget !== undefined) s.budget = t.patch.budget;
      if (t.patch.drop) s.pieces = s.pieces.filter(function (p) { return p !== t.patch.drop; });
      if (t.patch.pal !== undefined) { s.pal = t.patch.pal; s.col = null; }
      var r = buildLooks(units, s, cfg, 1);
      if (r.looks.length) out.push({ label: t.label, patch: t.patch, looks: r.looks.length, items: allItems(units, s, cfg).items.length });
    });
    return out;
  }
  /* perché non esce nessun look: per ogni capo scelto, il primo filtro che lo azzera
     (occasione → colore → taglia → budget); se tutti i capi ci sono, il motivo è nell'insieme
     (protagonista assente sui capi principali, budget totale, colori che non si abbinano) */
  function diagnose(units, sel, cfg) {
    var ctx = makeCtx(units, sel, cfg), rule = ctx.rule, out = { roles: [], global: null };
    var tpls = templatesFor(ctx.pieces).filter(function (t) { return t.req.length > 1; });
    var need = {}; tpls.forEach(function (t) { t.req.forEach(function (r) { need[r] = 1; }); });
    var okRoles = {};
    Object.keys(need).forEach(function (r) {
      var all = units.filter(function (u) { return u.role === r; });
      var col = all.filter(function (u) { return u.color.classified && (u.color.metal ? !CLOTH[r] : rule.allowed.indexOf(u.color.base) >= 0); });
      var want = ctx.sz[r] || [];
      var sz = col.filter(function (u) { return r === 'borsa' || want.some(function (k) { return u.bySize[k]; }); });
      var bud = ctx.pools[r] || [];
      var sizes = {}; col.forEach(function (u) { u.sizeKeys.forEach(function (k) { sizes[k] = 1; }); });
      var minP = null;
      sz.forEach(function (u) { want.forEach(function (k) { var v = u.bySize[k]; if (v && v.price != null && (minP === null || v.price < minP)) minP = v.price; }); });
      var cause = !all.length ? 'occasione' : !col.length ? 'colore' : !sz.length ? 'taglia' : !bud.length ? 'budget' : null;
      if (cause) out.roles.push({ role: r, cause: cause, sizes: Object.keys(sizes), minPrice: minP });
      else okRoles[r] = 1;
    });
    if (out.roles.length) return out;
    /* tutti i capi hanno candidati: controllo l'insieme */
    var t0 = tpls[0];
    if (rule.mode === 'p') {
      var big = t0 ? protRolesOf(t0.req) : [];
      if (!big.some(function (r) { return ctx.pools[r].some(function (e) { return e.prot; }); })) { out.global = { cause: 'protagonista', roles: big }; return out; }
    }
    if (ctx.T) {
      var minTot = minTotal(units, sel, cfg);
      if (minTot !== null && minTot > ctx.T) {
        /* quale capo aggiunto togliere per rientrare nel budget */
        var drops = EXTRA_PIECES.filter(function (x) {
          if (ctx.pieces.indexOf(x) < 0 || !hasLook(ctx.pieces.filter(function (p) { return p !== x; }))) return false;
          var m = minTotal(units, sel, cfg, x); return m !== null && m <= ctx.T;
        });
        out.global = { cause: 'budget', minTotal: minTot, drops: drops }; return out;
      }
    }
    out.global = { cause: 'abbinamento' };
    return out;
  }
  /* prezzo minimo di un look con questi capi, taglie e colori (senza tetto di budget).
     È un limite inferiore: se supera la fascia, con quella fascia il look è impossibile.
     null = non calcolabile (taglie non ancora scelte o capo senza candidati) */
  function minTotal(units, sel, cfg, drop) {
    var s = { occ: sel.occ, col: sel.col, pal: sel.pal, sizes: sel.sizes, budget: 0, brand: sel.brand || '*',
      pieces: (sel.pieces || []).filter(function (p) { return p !== drop; }) };
    var ctx = makeCtx(units, s, cfg), best = null;
    templatesFor(ctx.pieces).forEach(function (t) {
      if (t.req.length < 2) return;
      var sum = 0;
      for (var i = 0; i < t.req.length; i++) {
        var r = t.req[i], lvl = levelOf(r, t.req), m = null;
        ctx.pools[r].forEach(function (e) {
          if (ctx.rule.mode === 'p' && lvl === 60 && !e.prot && !isNeutral(e.u.color)) return;
          if (m === null || e.v.price < m) m = e.v.price;
        });
        if (m === null) return;
        sum += m;
      }
      if (best === null || sum < best) best = sum;
    });
    return best === null ? null : Math.round(best * 100) / 100;
  }
  /* capi obbligatori senza nessun capo utilizzabile (taglia + colori + budget) */
  function missingRoles(units, sel, cfg) {
    var ctx = makeCtx(units, sel, cfg), need = {}, out = [];
    templatesFor(ctx.pieces).forEach(function (t) { t.req.forEach(function (r) { need[r] = 1; }); });
    Object.keys(need).forEach(function (r) { if (!ctx.pools[r].length) out.push(r); });
    if (ctx.rule.mode === 'p') {
      var protAny = Object.keys(need).some(function (r) { return ctx.pools[r].some(function (e) { return e.prot; }); });
      if (!protAny) out.push('protagonista');
    }
    return out;
  }

  var Engine = { DEFAULTS: DEFAULTS, ascii: ascii, brandKey: brandKey, itSizes: itSizes, colorInfo: colorInfo, resolveRole: resolveRole,
    normalize: normalize, makeCtx: makeCtx, buildLooks: buildLooks, alternatives: alternatives, allItems: allItems, gridSuggest: gridSuggest,
    familyCounts: familyCounts, countForColor: countForColor, hints: hints, mergeCfg: mergeCfg, mulberry32: mulberry32,
    colorRule: colorRule, colorFits: colorFits, hasLook: hasLook, compatible: compatible, BASE_PIECES: BASE_PIECES, EXTRA_PIECES: EXTRA_PIECES, levelOf: levelOf, protRolesOf: protRolesOf, isNeutral: isNeutral, isGridMode: isGridMode,
    templatesFor: templatesFor, suggestSizes: suggestSizes, suggestions: suggestions, occTagsOf: occTagsOf,
    pieceStats: pieceStats, sizeOptions: sizeOptions, missingRoles: missingRoles, diagnose: diagnose, minTotal: minTotal, lookId: lookId,
    PIECES: PIECES, ROLE_LABEL: ROLE_LABEL, SZ_KEY: SZ_KEY, BASE_ROLES: BASE_ROLES };
  root.StylistEngine = Engine;
  if (typeof module !== 'undefined' && module.exports) module.exports = Engine;
  if (typeof document === 'undefined') return;

  /* ================================================================== *
   * 5. UI (solo browser)
   * ================================================================== */
  function boot() {
    var host = document.querySelector('[data-stylist]');
    if (!host) return;
    var cfgEl = document.getElementById(host.getAttribute('data-config-id'));
    var page = {};
    try { page = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[stylist] config non valida', e); }
    var cfg = mergeCfg(DEFAULTS, {});
    ['collection', 'apiVersion', 'seasonTag', 'token', 'endpoint'].forEach(function (k) { if (page[k]) cfg[k] = page[k]; });
    if (page.excludedTags) cfg.excludedTags = String(page.excludedTags).split(/\n|,/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (page.minRatio) cfg.minRatio = page.minRatio / 100;
    if (page.freeShipping != null) cfg.freeShipping = page.freeShipping;
    if (page.minBrandCount) cfg.minBrandCount = page.minBrandCount;
    if (page.minSizeCount) cfg.minSizeCount = page.minSizeCount;
    if (page.minPieceCount) cfg.minPieceCount = page.minPieceCount;
    if (page.minColorCount) cfg.minColorCount = page.minColorCount;
    if (page.neutrals) cfg.neutrals = String(page.neutrals).split(/[\n,]/).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    if (page.budgetBands) {
      var bb = String(page.budgetBands).split('\n').map(function (l) { var p = l.split('|'); return p.length === 2 ? { max: parseInt(p[0], 10) || 0, l: p[1].trim() } : null; }).filter(Boolean);
      if (bb.length) cfg.budgetBands = bb;
    }
    var famKeys = cfg.families.map(function (f) { return f.k; });
    /* nomi colore aggiuntivi: si AGGIUNGONO alla tabella di base (nome = famiglia) */
    if (page.colorMap) {
      var cm = {}; for (var ck in cfg.colorMap) cm[ck] = cfg.colorMap[ck];
      String(page.colorMap).split('\n').forEach(function (l) { var p = l.split('='); if (p.length === 2 && p[0].trim()) cm[slugToken(p[0])] = p[1].trim().toLowerCase(); });
      cfg.colorMap = cm;
    }
    /* abbinamenti: "verde = bianco, beige, marrone" (una riga per colore, sostituisce quella di base) */
    if (page.pairs) {
      var pr = {}; for (var pk in cfg.pairs) pr[pk] = cfg.pairs[pk];
      String(page.pairs).split('\n').forEach(function (l) {
        var p = l.split('='); if (p.length !== 2) return;
        var k = slugToken(p[0]); if (famKeys.indexOf(k) < 0) return;
        pr[k] = p[1].split(',').map(function (s) { return slugToken(s); }).filter(function (s) { return famKeys.indexOf(s) >= 0 && s !== k; });
      });
      cfg.pairs = pr;
    }
    /* palette di stagione dai blocchi della sezione (se ci sono, sostituiscono quelle di base) */
    if (page.palettes && page.palettes.length) {
      var pl = page.palettes.map(function (p) {
        return { name: String(p.name || '').trim(), desc: String(p.desc || '').trim(), push: String(p.push || '').trim(),
          cols: (p.cols || []).filter(function (c) { return famKeys.indexOf(c) >= 0; }) };
      }).filter(function (p) { return p.name && p.cols.length >= 2; }).slice(0, 6);
      if (pl.length) cfg.palettes = pl;
    }
    if (page.roleRules) {
      var rr = String(page.roleRules).split('\n').map(function (l) { var p = l.split('=>'); return p.length === 2 ? [p[0].trim(), p[1].trim()] : null; }).filter(Boolean);
      if (rr.length) { cfg.roleRules = rr; delete cfg._rules; }
    }
    if (page.sizeTables) { try { cfg.sizeTables = JSON.parse(page.sizeTables); } catch (e) { console.warn('[stylist] JSON taglie non valido'); } }
    var debugAllowed = !!page.debugAllowed;
    if (!cfg.token) console.warn('[stylist] Manca il token Storefront nelle impostazioni della sezione');
    var T = page.texts || {};
    var NAME = (T.name || '').trim() || 'Armonia';
    /* logo Armonia (SVG inline, un solo colore): sta nel cerchio dell'intro e nella colonna di sinistra */
    var LOGO = '<svg viewBox="0 0 638.36 507.47" aria-hidden="true" focusable="false"><path fill="currentColor" d="M437.22,452.24l42-101.43c33.87-81.8,69.05-161.41,108.25-240.82l50.07-101.44c1.13-2.3,1.01-5.51.02-6.96-.65-.94-2.76-1.79-5.05-1.56-57.27,5.9-174.35,121.82-215.44,169.44l-77.29,89.58c-10.85-14.16-24.04-25.72-40.61-32.56-30.66-12.66-64.01-2.08-81.2,26.32-24.92,40.41-9.59,93.73,20.36,131.46-26.21,30.49-54.08,58.95-87.35,81.58-32.3,21.96-85.03,38.61-112.13,14.01-7.77-7.06-10.7-20.03-6.11-29.52,3.12-6.46,10.36-9.87,16.77-11.67l26.05-7.33c19.92-5.61,30.71-24.5,26.72-44.78-2.61-13.26-10.7-23.94-24.09-28.33-23.56-7.73-48.77,1.54-63.08,22.87-15.8,23.54-19.54,54.82-9.65,81.81,8.17,22.32,27.71,36.8,50.29,42.14,40.07,9.47,83.44-10.2,116.12-34.9,28.71-21.7,53.64-46.5,77.32-73.75l14.86,14.73c24.12,20.91,51.37,36.53,81.17,47.51l-13.3,35.49,93.48-11.36,6.13-15.7M428.19,467.83c27.48-2.45,51.77-12.5,72.75-30.75,19.62-17.07,36.6-35.45,54.45-54.62-7.72.69-15.88,1.98-24.35,4.1-55.62,59.12-84.78,72.35-97.15,66.45M248.57,371.98c-24.45-36.2-13.26-87.22,24.8-108.93,19.79-11.29,42.85-8.15,56.91,9.01l-81.71,99.92ZM361.5,387.76c-2.24,18.82-5.9,36.11-11.32,56.32-35.47-11.95-66.64-32.48-91.62-59.91l81.41-100.83c18.99,32.56,25.58,68.32,21.52,104.42ZM409.86,338.39l-34.54,62.63c7.55-46.09-.24-90-25.6-129.45,38.3-46.99,75.1-92.49,117.16-134.23l42.34-42.02c28.11-26.04,57.25-49.62,92.64-68.18-67.32,103.46-131.25,205.42-192,311.26Z"/></svg>';
    function logoBadge(cls) { return '<span class="st-logo' + (cls ? ' ' + cls : '') + '" role="img" aria-label="' + esc(NAME) + '">' + LOGO + '</span>'; }

    /* app a schermo intero (come il Gustometro): copre la pagina, si chiude con la X o con Esc.
       Nell'editor del tema resta dentro la pagina, per poterla modificare. */
    /* L'intro resta dentro la pagina (header e footer del sito visibili). Da "Inizia" in poi lo stylist
       si apre a schermo intero con un'animazione che parte dalla card dell'intro. */
    var CAN_FULL = !page.designMode, FULL = false, BOOTED = false;
    var WRAP = host.parentNode && host.parentNode.classList && host.parentNode.classList.contains('st-wrap') ? host.parentNode : host;
    var REDUCE = false; try { REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* ok */ }
    function setFull(on) {
      if (!CAN_FULL || on === FULL) return;
      if (on && WRAP.classList.contains('st-full') && !BOOTED) {      // pagina aperta già a schermo intero (la sezione stampa st-full): niente clip, solo dissolvenza
        BOOTED = true; FULL = true; document.documentElement.classList.add('st-lock');
        if (!REDUCE) { WRAP.classList.add('st-bootin'); setTimeout(function () { WRAP.classList.remove('st-bootin'); }, 800); }
        return;
      }
      if (on) {
        var r = host.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
        var anim = !REDUCE && r.height > 0 && r.bottom > 0 && r.top < vh;
        FULL = true; WRAP.classList.add('st-full'); document.documentElement.classList.add('st-lock');
        if (anim) {
          WRAP.style.setProperty('--st-from', 'inset(' + Math.max(0, Math.round(r.top)) + 'px ' + Math.max(0, Math.round(vw - r.right)) + 'px ' +
            Math.max(0, Math.round(vh - r.bottom)) + 'px ' + Math.max(0, Math.round(r.left)) + 'px round 30px)');
          WRAP.classList.remove('st-enter'); void WRAP.offsetWidth; WRAP.classList.add('st-enter');
          setTimeout(function () { WRAP.classList.remove('st-enter'); }, 700);
        }
      } else {
        FULL = false; WRAP.classList.remove('st-full', 'st-enter'); document.documentElement.classList.remove('st-lock');
      }
    }
    host.innerHTML = '<aside class="st-side" id="st-side" aria-label="Le tue scelte"></aside><div class="st-main" id="st-main"></div>';
    var $ = document.getElementById('st-main'), SIDE = document.getElementById('st-side');
    function toTop() { [WRAP, $].forEach(function (el) { try { el.scrollTop = 0; } catch (e) { /* ok */ } }); if (!FULL) window.scrollTo({ top: Math.max(0, host.getBoundingClientRect().top + window.pageYOffset - 20) }); }
    /* chiudi = si torna da dove si è arrivati (stesso sito), altrimenti alla home. Le taglie restano ricordate sul dispositivo. */
    function closeApp() {
      emit('close', { step: stepOf(S) });
      var to = '/';
      try { var ref = document.referrer && new URL(document.referrer); if (ref && ref.origin === location.origin && ref.pathname !== location.pathname) to = ref.href; } catch (e) { /* ok */ }
      if (!FULL) return;
      document.documentElement.classList.remove('st-lock');
      window.location.assign(to);
    }
    document.addEventListener('keydown', function (e) {
      if (FULL && e.key === 'Escape' && !document.querySelector('cart-drawer.active, .drawer.active')) closeApp();
    });
    var XICO = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    function xBtn() { return FULL ? '<button class="st-x" data-act="close" aria-label="Chiudi lo stylist">' + XICO + '</button>' : ''; }
    var utm = {};
    (function () {
      try {
        utm = JSON.parse(sessionStorage.getItem('stylist_utm') || '{}');
        new URLSearchParams(location.search).forEach(function (v, k) { if (/^utm_|^fbclid$/.test(k)) utm[k] = v; });
        sessionStorage.setItem('stylist_utm', JSON.stringify(utm));
      } catch (e) { /* ok */ }
    })();

    /* ---------- utilità UI ---------- */
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function eur(n) { return n == null ? '' : n.toLocaleString('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
    function emit(name, detail) {
      detail = detail || {}; detail.utm = utm;
      try { document.dispatchEvent(new CustomEvent('stylist:' + name, { detail: detail })); } catch (e) { /* ok */ }
    }
    var tick = '<span class="st-tick"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg></span>';
    var occLabel = {}; cfg.occasions.forEach(function (o) { occLabel[o.k] = o.l; });
    var famLabel = {}, famHex = {}; cfg.families.forEach(function (p) { famLabel[p.k] = p.l; famHex[p.k] = p.hex; });
    famHex.oro = '#B08A57'; famHex.argento = '#B9B9BD'; famLabel.oro = 'Oro'; famLabel.argento = 'Argento';
    var CAT_LABEL = { top: 'Top', pantalone: 'Pantaloni', gonna: 'Gonne', abito: 'Abiti', capospalla: 'Capospalla', scarpe: 'Scarpe', borsa: 'Borse' };
    var PIECE_TXT = { top: 'Top', pantalone: 'Pantalone', gonna: 'Gonna', abito: 'Abito', capospalla: 'Capospalla', scarpe: 'Scarpe', borsa: 'Borsa' };
    var NUM_KEYS = { sotto: 1, scarpe: 1 };      // righe taglia solo a numeri (niente XS/S/M)
    var PIECE_SUB = { top: 'Maglie, camicie, t-shirt', pantalone: 'Anche jeans', gonna: 'Corte, midi, lunghe', abito: 'Vestiti e completi', capospalla: 'Giacche e cappotti', scarpe: 'Per ogni numero', borsa: 'Da giorno e da sera' };
    function hexOf(u) { return u.color.denim ? '#4F6F99' : (famHex[u.color.base] || '#CFC4BB'); }
    function colorName(u) { return u.color.denim ? 'Denim' : (famLabel[u.color.base] || u.color.base); }
    function dotStyle(k) { return k === 'fantasia' ? 'background:conic-gradient(#211C1D 0 25%,#CDB596 0 50%,#7A1F2B 0 75%,#F3EEE4 0)' : 'background:' + (famHex[k] || '#CFC4BB'); }
    var LET = { 34: 'XS', 36: 'XS', 38: 'XS', 40: 'S', 42: 'M', 44: 'L', 46: 'XL' };          // metro standard (Vicolo, Armonia...) solo per l'etichetta
    var LETTER_KEYS = { top: 1, abito: 1, capospalla: 1 };      // capi alti: lettere + numero; sotto: solo numeri
    function ownLabel(role, k) { return (LETTER_KEYS[role] && LET[k]) ? LET[k] + ' (' + k + ')' : String(k); }
    function sizeTxt(s, role) { return s === 'TU' ? 'taglia unica' : ownLabel(role || 'sotto', s); }
    var LGROUPS = [['XS', ['34', '36', '38']], ['S', ['40']], ['M', ['42']], ['L', ['44']], ['XL', ['46']]];
    function brandSize(raw) {
      if (raw == null) return '';
      var f = Engine.ascii(raw).replace(/[()]/g, ' ').replace(/[_\/]/g, '-').replace(/-/g, ' ');
      [[/extra\s*small/g, 'xs'], [/extra\s*large/g, 'xl'], [/\bsmall\b/g, 's'], [/\bmedium\b/g, 'm'], [/\blarge\b/g, 'l']].forEach(function (w) { f = f.replace(w[0], w[1]); });
      var t = f.split(/\s+/).filter(function (x) { return /^(xxs|xs|s|m|l|xl|xxl)$/.test(x); });
      if (t.length) return t.map(function (x) { return x.toUpperCase(); }).join('/');
      var n = f.match(/\d{2}/g); return n ? n.slice(0, 2).join('-') : '';
    }

    /* ---------- memoria locale (solo dispositivo; Klaviyo in fase 4) ---------- */
    var MEM_KEY = 'stylist_profile_v2';
    var Mem = {
      load: function () { try { return JSON.parse(localStorage.getItem(MEM_KEY) || '{"r":[]}'); } catch (e) { return { r: [] }; } },
      add: function (r) { try { var m = Mem.load(); m.r.push(r); m.r = m.r.slice(-20); localStorage.setItem(MEM_KEY, JSON.stringify(m)); } catch (e) { /* ok */ } },
      /* taglia più frequente negli ultimi 3 eventi, per capo */
      pref: function (piece) {
        var c = {}, best = null;
        Mem.load().r.slice(-3).forEach(function (x) {
          ((x.sz && x.sz[piece]) || []).forEach(function (s) { c[s] = (c[s] || 0) + 1; if (!best || c[s] >= c[best]) best = s; });
        });
        return best ? [best] : [];
      },
      clear: function () { try { localStorage.removeItem(MEM_KEY); } catch (e) { /* ok */ } }
    };

    /* ---------- stato + URL ---------- */
    function emptySz() { return { top: [], sotto: [], abito: [], capospalla: [], scarpe: [] }; }
    function parseSizes(v) {
      var out = [];
      (v || '').split(',').forEach(function (x) {
        x = x.trim(); var k = /^tu$/i.test(x) ? 'TU' : (/^\d{2}$/.test(x) ? x : null);
        if (k && out.indexOf(k) < 0) out.push(k);
      });
      return out;
    }
    /* righe taglia richieste dai capi scelti */
    function sizeKeysOf(s) { return uniq(s.pieces.map(function (p) { return SZ_KEY[p]; }).filter(Boolean)); }
    function sizesComplete(s) { return Engine.hasLook(s.pieces) && sizeKeysOf(s).every(function (k) { return s.sz[k] && s.sz[k].length; }); }
    function hasColor(s) { return !!s.col || s.pal != null; }
    var S = parseURL(), DATA = { occ: null, status: 'idle', units: [], excluded: [], error: null }, LOOKS = [], CTX = null, ALL = [], VIS = [], SHOWN = 8, CAT = 'all', GRID = false;
    var reqSeq = 0;

    function parseURL() {
      var p = new URLSearchParams(location.search), s = {};
      var occ = p.get('occ'); if (occ === 'weekend') occ = 'daily';
      s.occ = cfg.occasions.some(function (o) { return o.k === occ; }) ? occ : null;
      /* colore: col=verde (protagonista) | pal=1..3 (palette) | col=auto (scelta di Armonia). Vecchi link: col=nero,rosso -> nero */
      var col = (p.get('col') || '').split(',')[0];
      s.col = famKeys.indexOf(col) >= 0 ? col : null;
      var pal = parseInt(p.get('pal'), 10); s.pal = (!s.col && pal >= 1 && pal <= cfg.palettes.length) ? pal - 1 : null;
      s.auto = p.get('auto') === '1' && s.pal != null;
      if (!s.col && s.pal == null && (col === 'auto' || col === 'tutti')) s.wantAuto = true;
      /* capi: c=top,pantalone,capospalla. Vecchi link: c=top,sotto (+ so=pantalone|gonna) */
      var c = (p.get('c') || '').split(',').filter(Boolean), so = p.get('so');
      if (c.indexOf('sotto') >= 0) { if (so !== 'gonna') c.push('pantalone'); if (so !== 'pantalone') c.push('gonna'); }
      s.pieces = PIECES.filter(function (x) { return c.indexOf(x) >= 0; });
      s.sz = { top: parseSizes(p.get('tt')), sotto: parseSizes(p.get('ts')), abito: parseSizes(p.get('ta')), capospalla: parseSizes(p.get('tc')), scarpe: parseSizes(p.get('tz')) };
      var need = sizeKeysOf(s); Object.keys(s.sz).forEach(function (k) { if (need.indexOf(k) < 0) s.sz[k] = []; });
      var b = p.get('b'); s.budget = null;
      if (b !== null && cfg.budgetBands.some(function (x) { return String(x.max) === b; })) s.budget = parseInt(b, 10);
      s.seed = parseInt(p.get('seed'), 10) || null;
      s.brand = '*';                       // filtro brand tolto dal risultato (assortimento non uniforme tra brand)
      s.go = true;           // niente schermata iniziale: lo stylist parte dalla scelta dell'occasione
      var e = p.get('e'); s.edit = { occ: 'occ', col: 'col', cap: 'cap', tg: 'tg', 1: 'cap', 2: 'cap', 3: 'tg' }[e] || null;
      s.debug = p.get('debug') === '1' && debugAllowed;
      return s;
    }
    /* -1 intro · 0 occasione · 1 colore · 2 capi · 3 taglie e budget · 4 risultato */
    function stepOf(s) {
      if (!s.occ) return s.go ? 0 : -1;
      if (s.edit === 'occ') return 0;
      if (!hasColor(s) || s.edit === 'col') return 1;
      if (s.edit === 'cap' || !Engine.hasLook(s.pieces)) return 2;
      if (s.edit === 'tg' || !sizesComplete(s) || s.budget === null) return 3;
      return 4;
    }
    function buildQuery(s) {
      var p = new URLSearchParams(location.search), keep = new URLSearchParams();
      p.forEach(function (v, k) { if (/^utm_|^fbclid$|^view$|^preview_theme_id$/.test(k)) keep.set(k, v); });   // view = modello alternativo (anteprima di un tema non pubblicato)
      if (s.occ) keep.set('occ', s.occ);
      if (s.col) keep.set('col', s.col);
      else if (s.pal != null) { keep.set('pal', String(s.pal + 1)); if (s.auto) keep.set('auto', '1'); }
      if (s.pieces.length) keep.set('c', s.pieces.join(','));
      [['tt', 'top'], ['ts', 'sotto'], ['ta', 'abito'], ['tc', 'capospalla'], ['tz', 'scarpe']].forEach(function (x) {
        var arr = s.sz[x[1]]; if (arr && arr.length) keep.set(x[0], arr.map(function (v) { return v === 'TU' ? 'tu' : v; }).join(','));
      });
      if (s.budget !== null) keep.set('b', String(s.budget));
      if (s.seed && s.budget !== null) keep.set('seed', String(s.seed));
      if (s.brand && s.brand !== '*') keep.set('br', s.brand);
      if (s.edit) keep.set('e', s.edit);
      if (s.debug) keep.set('debug', '1');
      var q = keep.toString(); return location.pathname + (q ? '?' + q : '');
    }
    function syncURL() { try { history.replaceState({ st: 1 }, '', buildQuery(S)); } catch (e) { /* ok */ } }
    function nav(replace) {
      try { history[replace ? 'replaceState' : 'pushState']({ st: 1 }, '', buildQuery(S)); } catch (e) { /* ok */ }
      render();
    }
    window.addEventListener('popstate', function () { S = parseURL(); CAT = 'all'; render(); });

    /* ---------- dati ---------- */
    var endpoint = cfg.endpoint || ('https://' + (page.shopDomain || location.host) + '/api/' + cfg.apiVersion + '/graphql.json');
    function gql(query, variables) {
      return fetch(endpoint, { method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token || '' },
        body: JSON.stringify({ query: query, variables: variables || {} }) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    }
    function productQuery(useAnc) {
      return 'query StylistProducts($handle:String!,$first:Int!,$after:String,$filters:[ProductFilter!]) @inContext(country: IT, language: IT){' +
        'collection(handle:$handle){products(first:$first,after:$after,filters:$filters){pageInfo{hasNextPage endCursor}nodes{' +
        'id handle title vendor tags productType ' +
        'category{name' + (useAnc ? ' ancestors{name}' : '') + '} ' +
        'colorMf:metafield(namespace:"shopify",key:"color-pattern"){references(first:6){nodes{...on Metaobject{handle fields{key value}}}}} ' +
        'models:metafield(namespace:"custom",key:"varianti_colore"){references(first:12){nodes{...on Product{handle}}}} ' +
        'featuredImage{url(transform:{maxWidth:480})} ' +
        'variants(first:40){nodes{id availableForSale price{amount} compareAtPrice{amount} selectedOptions{name value} image{url(transform:{maxWidth:480})}}}' +
        '}}}}';
    }
    var SS_KEY = 'stylist_data_v3_';
    /* un caricamento per tag occasione (daily legge anche occ:weekend), poi unione per id */
    function fetchTag(tag, mode) {
      var all = [], after = null, guard = 0;
      function step() {
        if (guard++ > 12) return Promise.resolve(all);
        var vars = { handle: cfg.collection, first: cfg.pageSize, after: after,
          filters: mode.filtered ? [{ tag: tag }, { available: true }] : null };
        return gql(productQuery(mode.anc), vars).then(function (res) {
          if (res.errors && !(res.data && res.data.collection)) {
            var msg = res.errors.map(function (e) { return e.message; }).join(' | ');
            if (mode.anc && /ancestors/i.test(msg)) { mode.anc = false; return step(); }
            if (mode.filtered && /filter|tag|available/i.test(msg)) { mode.filtered = false; after = null; all = []; return step(); }
            throw new Error(msg);
          }
          var col = res.data && res.data.collection;
          if (!col) throw new Error('Collezione "' + cfg.collection + '" non trovata (controlla handle e permessi del token)');
          all = all.concat(col.products.nodes);
          if (col.products.pageInfo.hasNextPage) { after = col.products.pageInfo.endCursor; return step(); }
          return all;
        });
      }
      return step();
    }
    function fetchOccasion(occ) {
      try {
        var c = JSON.parse(sessionStorage.getItem(SS_KEY + occ) || 'null');
        if (c && Date.now() - c.t < 10 * 60 * 1000 && c.v === 3) return Promise.resolve(c.d);
      } catch (e) { /* ok */ }
      var tags = Engine.occTagsOf(occ, cfg), mode = { anc: true, filtered: true }, seen = {}, all = [];
      return tags.reduce(function (pr, tag) {
        return pr.then(function () {
          if (!mode.filtered && all.length) return;            // senza filtri basta un giro: filtro locale
          return fetchTag(tag, mode).then(function (nodes) {
            nodes.forEach(function (n) { if (!seen[n.id]) { seen[n.id] = 1; all.push(n); } });
          });
        });
      }, Promise.resolve()).then(function () {
        var out = normalize(all, cfg, occ);
        out.total = all.length;
        try { sessionStorage.setItem(SS_KEY + occ, JSON.stringify({ t: Date.now(), v: 3, d: out })); } catch (e) { /* quota */ }
        return out;
      });
    }
    function ensureData() {
      if (!S.occ) return;
      if (DATA.occ === S.occ && DATA.status !== 'idle') return; // 'error' è terminale: si riparte solo con Riprova
      var my = ++reqSeq; DATA = { occ: S.occ, status: 'loading', units: [], excluded: [], error: null };
      fetchOccasion(S.occ).then(function (d) {
        if (my !== reqSeq) return;
        DATA.units = d.units; DATA.excluded = d.excluded; DATA.total = d.total; DATA.status = 'ready';
        onDataReady();
      }).catch(function (e) {
        if (my !== reqSeq) return;
        console.error('[stylist]', e); DATA.status = 'error'; DATA.error = e.message; onDataReady();
      });
    }
    function onDataReady() {
      if (S.wantAuto && DATA.status === 'ready') { pickAuto(); syncURL(); }
      var st = stepOf(S);
      if (st >= 1) render();
    }

    /* palette disponibili (almeno minPieceCount capi nei loro colori) e scelta di Armonia */
    function famCounts() { return DATA.status === 'ready' ? Engine.familyCounts(DATA.units) : null; }
    function palOK(i) {
      var fc = famCounts(); if (!fc) return true;
      var p = cfg.palettes[i], n = 0; p.cols.forEach(function (c) { n += fc[c] || 0; });
      return n >= cfg.minPieceCount * 2;
    }
    function pickAuto() {
      var ok = cfg.palettes.map(function (_, i) { return i; }).filter(palOK);
      if (!ok.length) ok = cfg.palettes.map(function (_, i) { return i; });
      S.pal = ok[Math.floor(Math.random() * ok.length)]; S.col = null; S.auto = true; S.wantAuto = false;
    }
    function colorTitle() {
      if (S.col) return famLabel[S.col];
      if (S.pal != null && cfg.palettes[S.pal]) return cfg.palettes[S.pal].name;
      return '';
    }

    /* ---------- viste ---------- */
    var ICONS = {
      hanger: '<path d="M12 7a2.5 2.5 0 1 0-2.5-2.5M12 7v2.2l9 6.3a1.5 1.5 0 0 1-.9 2.7H3.9A1.5 1.5 0 0 1 3 15.5l9-6.3"/>',
      sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
      briefcase: '<rect x="3" y="7" width="18" height="13" rx="3"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M3 13h18"/>',
      moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
      sparkle: '<path d="M11 3l1.8 5.2L18 10l-5.2 1.8L11 17l-1.8-5.2L4 10l5.2-1.8zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/>',
      top: '<path d="M8 3L3 6l2 4 3-1v11h8V9l3 1 2-4-5-3c-.5 1.5-2 2.5-4 2.5S8.5 4.5 8 3z"/>',
      pantalone: '<path d="M7 3h10l1 18h-4.5L12 10l-1.5 11H6z"/>',
      gonna: '<path d="M8 4h8l3.5 15c-2 1.3-4.6 2-7.5 2s-5.5-.7-7.5-2z"/><path d="M8 7h8"/>',
      abito: '<path d="M9 3h6l.6 5-2 3L18 21H6l4.4-10-2-3z"/>',
      capospalla: '<path d="M9 3l3 3 3-3 5 4-2 5-2-1v10H8V11l-2 1-2-5z"/><path d="M12 6v14"/>',
      scarpe: '<path d="M3 16.5V9.5c2 0 3.5 1 5 2.5l2.5 1.5c3 .6 6.5 1 8.5 2.2 1.2.7 2 1.8 2 2.8H4a1 1 0 0 1-1-1z"/><path d="M3 18.5h18"/>',
      borsa: '<path d="M5 9h14l-1 11H6z"/><path d="M9 9V7a3 3 0 0 1 6 0v2"/>',
      swap: '<path d="M4 7h13l-3-3M20 17H7l3 3"/>',
      share: '<path d="M12 15V3M8 7l4-4 4 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/>',
      edit: '<path d="M4 20h4L19 9l-4-4L4 16zM13 7l4 4"/>'
    };
    var OCC_ICON = { daily: 'sun', ufficio: 'briefcase', sera: 'moon', cerimonia: 'sparkle' };
    function ico(n) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[n] || '') + '</svg>'; }
    var toastT = null;
    function toast(msg) {
      var el = document.getElementById('st-toast');
      if (!el) { el = document.createElement('div'); el.id = 'st-toast'; el.className = 'st-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
      el.textContent = msg; el.classList.add('on');
      clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('on'); }, 2600);
    }
    function head(step) {
      var seg = ''; for (var i = 0; i < 4; i++) seg += '<i' + (i <= step ? ' class="on"' : '') + '></i>';
      return '<div class="st-top"><button class="st-back" data-act="back" aria-label="Passo precedente"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<div class="st-prog"><span class="st-stepn">' + (step + 1) + ' di 4</span><div class="st-seg" aria-hidden="true">' + seg + '</div></div>' + (xBtn() || '<span class="st-xsp"></span>') + '</div>';
    }
    /* desktop: colonna con le scelte fatte, ognuna cliccabile per cambiarla */
    function drawSide(st) {
      if (st < 0) { host.classList.remove('st-sided'); SIDE.innerHTML = ''; return; }
      host.classList.add('st-sided');
      var bd = cfg.budgetBands.filter(function (b) { return b.max === S.budget; })[0];
      var szTxt = sizesComplete(S) ? sizeKeysOf(S).map(function (k) { return rolesOfKey(k).map(function (r) { return PIECE_TXT[r]; }).join('/') + ' ' + S.sz[k].map(function (z) { return (!NUM_KEYS[k] && LET[z]) ? LET[z] : sizeTxt(z, k); }).filter(function (z, i, a) { return a.indexOf(z) === i; }).join('/'); }).join(' · ') : '';
      var items = [
        ['occ', 'Occasione', S.occ ? occLabel[S.occ] : ''],
        ['col', 'Colore', hasColor(S) ? (S.auto ? 'Scelto da ' + NAME + ': ' : '') + colorTitle() : ''],
        ['cap', 'Capi', Engine.hasLook(S.pieces) ? S.pieces.map(function (r) { return PIECE_TXT[r]; }).join(' + ') : ''],
        ['tg', 'Taglie e budget', szTxt && S.budget !== null ? szTxt + (bd ? ' · ' + bd.l : '') : '']
      ];
      SIDE.innerHTML = '<div class="st-sidehd">' + logoBadge('st-av') +
        '<span><b>' + esc(NAME) + '</b><small>' + esc(T.kicker || 'Stylist virtuale') + '</small></span></div>' +
        '<p class="st-sidet">' + esc(T.title || 'Creiamo insieme il tuo look in 4 passaggi.') + '</p><ol class="st-steplist">' +
        items.map(function (it, i) {
          var cur = i === st, done = !!it[2] && !cur;
          var dot = done ? '<i class="st-sdot st-done"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg></i>' : '<i class="st-sdot">' + (i + 1) + '</i>';
          var body = '<span class="st-stx"><b>' + it[1] + '</b>' + (it[2] ? '<small>' + esc(it[2]) + '</small>' : '') + '</span>';
          if (done) return '<li><button class="st-step" data-act="goto" data-v="' + it[0] + '" aria-label="Cambia ' + it[1].toLowerCase() + '">' + dot + body + '<svg class="st-sedit" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16zM13 7l4 4"/></svg></button></li>';
          return '<li><span class="st-step' + (cur ? ' st-cur' : ' st-next') + '"' + (cur ? ' aria-current="step"' : '') + '>' + dot + body + '</span></li>';
        }).join('') + '</ol>' +
        (st === 4 ? '<button class="st-sidenew" data-act="again">Nuova ricerca</button>' : '<p class="st-sidenote">Tocca una scelta fatta per cambiarla.</p>');
    }

    function viewOcc() {
      $.innerHTML = head(0) + '<section class="st-q st-fade"><h2>Per quale occasione?</h2><p class="st-hint">Tocca quella che ti serve: passi da sola al passaggio dopo.</p><div class="st-opts st-c5">' +
        cfg.occasions.map(function (o) {
          return '<button class="st-opt" data-act="occ" data-v="' + o.k + '" aria-pressed="' + (S.occ === o.k) + '"><span class="st-ic">' + ico(OCC_ICON[o.k] || 'sparkle') + '</span><b>' + esc(o.l) + '</b><small>' + esc(o.d) + '</small>' + tick + '</button>';
        }).join('') + '</div></section>';
    }

    /* passaggio 2: un colore protagonista, oppure una palette di stagione, oppure "Scegli tu" */
    function viewCol() {
      var fc = famCounts(), min = cfg.minColorCount;
      var fams = cfg.families.filter(function (f) { return !fc || (fc[f.k] || 0) >= min; });
      var h = head(1) + '<section class="st-q st-fade"><h2>Che colore ti va di indossare?</h2>' +
        '<p class="st-hint">Scegline uno: gli abbinamenti giusti li trovo io.</p>';
      if (!fc && DATA.status !== 'error') h += '<p class="st-count" role="status">Sto controllando i colori disponibili…</p>';
      h += '<div class="st-colors" role="group" aria-label="Colore protagonista">' + fams.map(function (f) {
        return '<button class="st-col" data-act="col" data-v="' + f.k + '" aria-pressed="' + (S.col === f.k) + '">' + tick +
          '<span class="st-dot" style="' + dotStyle(f.k) + '"></span><b>' + esc(f.l) + '</b></button>';
      }).join('') + '</div>';
      var pals = cfg.palettes.map(function (p, i) { return { p: p, i: i }; }).filter(function (x) { return palOK(x.i); });
      if (pals.length) {
        h += '<div class="st-sub">Le palette della stagione</div><div class="st-pals">' + pals.map(function (x) {
          return '<button class="st-pal" data-act="pal" data-v="' + x.i + '" aria-pressed="' + (S.pal === x.i && !S.auto) + '">' + tick +
            '<span class="st-sw">' + x.p.cols.map(function (c) { return '<i style="' + dotStyle(c) + '"></i>'; }).join('') + '</span>' +
            '<b>' + esc(x.p.name) + '</b>' + (x.p.desc ? '<small>' + esc(x.p.desc) + '</small>' : '') + '</button>';
        }).join('') + '</div>';
      }
      h += '<button class="st-auto" data-act="auto" aria-pressed="' + !!S.auto + '"><span class="st-ic">' + ico('sparkle') + '</span><span><b>Scegli tu, ' + esc(NAME) + '</b><small>Ti propongo io una palette di stagione</small></span>' + tick + '</button>';
      h += '<p class="st-tapnote">Tocca un colore o una palette: passi da sola al passaggio dopo.</p></section>';
      $.innerHTML = h;
      updateCount();
    }
    function updateCount() {
      var el = document.getElementById('st-count'); if (!el) return;
      var nx = document.getElementById('st-next'); if (nx) nx.disabled = !hasColor(S);
      if (!hasColor(S) || DATA.status !== 'ready') { el.textContent = ''; return; }
      var n = Engine.countForColor(DATA.units, selOf(), cfg);
      el.textContent = (S.col ? famLabel[S.col] + ' e i suoi abbinamenti: ' : 'Palette «' + colorTitle() + '»: ') + n + (n === 1 ? ' capo' : ' capi');
    }

    /* passaggio 3: quali capi (scelta libera) */
    function pieceCount(role) { return DATA.status === 'ready' ? Engine.pieceStats(DATA.units, [role], selOf(), cfg).n : null; }
    function viewPieces(fade) {
      var min = cfg.minPieceCount;
      var card = function (r) {
        var n = pieceCount(r), on = S.pieces.indexOf(r) >= 0, ok = n === null || n >= min || on;
        var sub = n === null ? PIECE_SUB[r] : (n >= min ? n + (n === 1 ? ' capo' : ' capi') : 'Al momento pochi capi');
        return '<button class="st-opt' + (ok ? '' : ' st-off') + '" data-act="piece" data-v="' + r + '" aria-pressed="' + on + '"' + (ok ? '' : ' aria-disabled="true"') + '>' +
          '<span class="st-ic">' + ico(r) + '</span><b>' + PIECE_TXT[r] + '</b><small>' + esc(sub) + '</small>' + tick + '</button>';
      };
      var h = head(2) + '<section class="st-q' + (fade ? ' st-fade' : '') + '"><h2>Cosa cerchi?</h2>' +
        '<p class="st-hint">Scegli almeno 2 capi: li abbiniamo in look da indossare insieme.</p>' +
        '<div class="st-opts st-c2 st-pieces">' + PIECES.map(card).join('') + '</div>';
      h += '<p class="st-note" id="st-pmsg" role="status" hidden></p>' +
        '<div class="st-actbar"><p class="st-count" id="st-pdesc">' + esc(piecesDesc()) + '</p><button class="st-cta st-next" id="st-next" data-act="pnext"' + (Engine.hasLook(S.pieces) ? '' : ' disabled') + '>Continua</button></div></section>';
      $.innerHTML = h;
    }
    function piecesDesc() {
      var has = function (p) { return S.pieces.indexOf(p) >= 0; };
      if (!S.pieces.length) return '';
      if (!Engine.hasLook(S.pieces)) return 'Scegli almeno un altro capo.';
      var t = Engine.templatesFor(S.pieces).filter(function (x) { return x.req.length > 1; });
      return 'Fino a 3 look: ' + t.map(function (x) { return x.req.map(function (r) { return PIECE_TXT[r].toLowerCase(); }).join(' + '); }).join(' oppure ') + '.';
    }

    /* passaggio 4: taglie per capo + budget */
    function chipBtn(key, v, label) {
      var html = esc(label), ks = String(v).split(','), cur = S.sz[key] || [];
      if (!NUM_KEYS[key] && LET[ks[0]]) html = '<b>' + LET[ks[0]] + '</b><i>' + (ks.length > 1 ? ks[0] + '–' + ks[ks.length - 1] : ks[0]) + '</i>';
      return '<button class="st-chip" data-act="psize" data-k="' + key + '" data-v="' + v + '" aria-pressed="' + ks.every(function (k) { return cur.indexOf(k) >= 0; }) + '">' + html + '</button>';
    }
    function rolesOfKey(key) { return S.pieces.filter(function (p) { return SZ_KEY[p] === key; }); }
    function sizeRow(key) {
      var roles = rolesOfKey(key), stats = Engine.pieceStats(DATA.units, roles, selOf(), cfg);
      var label = roles.map(function (r) { return PIECE_TXT[r]; }).join(' e ');
      var o = Engine.sizeOptions(stats, cfg), cur = S.sz[key] || [], list = o.sizes.slice();
      cur.forEach(function (s) { if (s !== 'TU' && list.indexOf(s) < 0) list.push(s); });
      list.sort(function (a, b) { return a - b; });
      var h = '';
      if (o.tu || cur.indexOf('TU') >= 0) h += chipBtn(key, 'TU', 'Taglia unica');
      if (NUM_KEYS[key]) list.forEach(function (s) { h += chipBtn(key, s, s); });
      else {
        var used = {};
        LGROUPS.forEach(function (g) {
          var ks = g[1].filter(function (k) { return list.indexOf(k) >= 0; });
          if (ks.length) { ks.forEach(function (k) { used[k] = 1; }); h += chipBtn(key, ks.join(','), g[0]); }
        });
        list.forEach(function (s) { if (!used[s]) h += chipBtn(key, s, s); });
      }
      if (!h) h = '<p class="st-help">Nessuna taglia disponibile nei colori scelti.</p>';
      return '<div class="st-prow"><div class="st-plabel">' + esc(label) + '</div><div class="st-chips" data-g="' + key + '">' + h + '</div>' +
        (o.tu ? '<p class="st-help">Taglia unica: veste dalla 40 alla 44.</p>' : '') + '</div>';
    }
    function prefill() {
      sizeKeysOf(S).forEach(function (k) {
        if (S.sz[k] && S.sz[k].length) return;
        var pref = Mem.pref(k); if (!pref.length) return;
        if (DATA.status === 'ready') {
          var o = Engine.sizeOptions(Engine.pieceStats(DATA.units, rolesOfKey(k), selOf(), cfg), cfg);
          if (!(pref[0] === 'TU' ? o.tu : o.sizes.indexOf(pref[0]) >= 0)) return;
        }
        S.sz[k] = pref;
      });
    }
    function ready4() { return sizesComplete(S) && S.budget !== null; }
    /* fasce di budget: tutte selezionabili; se il look non ci sta, lo spiega la diagnosi nei risultati */
    function budHTML() {
      return '<div class="st-chips st-bud">' + cfg.budgetBands.map(function (b) {
        return '<button class="st-chip" data-act="budget" data-v="' + b.max + '" aria-pressed="' + (S.budget === b.max) + '">' + esc(b.l) + '</button>';
      }).join('') + '</div>';
    }
    function refreshBud() {
      var w = document.getElementById('st-budw'); if (!w) return;
      w.innerHTML = budHTML();
      var nx = document.getElementById('st-next'); if (nx) nx.disabled = !ready4();
    }
    function viewSizes(fade) {
      var grid = Engine.isGridMode(S.pieces);
      var h = head(3) + '<section class="st-q' + (fade ? ' st-fade' : '') + '"><h2>Taglia e budget</h2><p class="st-hint">Ti mostro solo le taglie dei capi che ci sono davvero.</p>';
      if (DATA.status !== 'ready') h += '<p class="st-count" role="status">Sto controllando le taglie disponibili…</p>';
      else h += sizeKeysOf(S).map(sizeRow).join('');
      h += '<div class="st-sub">' + (grid ? 'Quanto vuoi spendere per un capo?' : 'Quanto vuoi spendere per il look?') + '</div><div id="st-budw">' + budHTML() + '</div>' +
        '<div class="st-actbar"><button class="st-cta st-next" id="st-next" data-act="show"' + (ready4() ? '' : ' disabled') + '>' + (grid ? 'Mostra i capi' : 'Mostra i look') + '</button></div></section>';
      $.innerHTML = h;
    }

    function viewLoading(msg) {
      var sk = '<div class="st-sk"><i></i><i></i><i></i></div>';
      $.innerHTML = '<div class="st-wait st-fade" role="status"><p>' + esc(msg || 'Sto componendo i tuoi look…') + '</p>' + sk + sk + '</div>';
    }
    function viewError() {
      $.innerHTML = '<div class="st-empty st-fade"><p><b>Non riusciamo a caricare i capi in questo momento.</b></p><p>Riprova tra qualche istante.</p><button class="st-cta" data-act="retry">Riprova</button>' +
        ((S.debug || debugAllowed) ? '<pre class="st-pre">Dettaglio tecnico (visibile solo nel tema di prova):\n' + esc(DATA.error) + '</pre>' : '') + '</div>';
    }

    /* ---------- risultato ---------- */
    function priceHTML(v) {
      return (v.compare && v.compare > v.price ? '<s class="st-old">' + eur(v.compare) + '</s> ' : '') + '<span class="st-price">' + eur(v.price) + '</span>';
    }
    function skLabel(p) {
      if (p.role === 'borsa' || p.role === 'accessorio') return 'Disponibile';
      if (p.role === 'scarpe') return 'Numero ' + p.sk + ' disponibile';
      if (p.sk === 'TU') return 'Taglia unica disponibile';
      var br = brandSize(p.v && p.v.sizeLabel), own = ownLabel(p.role, p.sk);
      if (!br) return 'Taglia ' + own + ' disponibile';
      var same = br === String(p.sk) || (LETTER_KEYS[p.role] && LET[p.sk] && br.split('/').indexOf(LET[p.sk]) >= 0);
      return 'Taglia ' + br + ' disponibile' + (same ? '' : ' · per te la ' + own);
    }
    function pieceHTML(p, li, pi) {
      var u = p.u;
      return '<div class="st-pc"><div class="st-ph">' + (p.v.img ? '<img src="' + esc(p.v.img) + '" alt="' + esc(u.title) + '" loading="lazy" width="240" height="320">' : '') +
        '<span class="st-slot">' + ROLE_LABEL[p.role] + '</span>' +
        '<button class="st-swap" data-act="swap" data-l="' + li + '" data-p="' + pi + '" aria-label="Cambia ' + ROLE_LABEL[p.role].toLowerCase() + '">' + ico('swap') + '</button></div>' +
        '<div class="st-info"><span class="st-brand">' + esc(u.brand) + '</span><a class="st-title" href="/products/' + esc(u.handle) + '?variant=' + esc(p.v.id) + '" target="_blank" rel="noopener">' + esc(u.title) + '</a>' +
        '<span class="st-meta"><i style="background:' + hexOf(u) + '"></i>' + esc(colorName(u)) + '</span>' +
        '<span class="st-prices">' + priceHTML(p.v) + '</span>' +
        '<span class="st-okk">' + esc(skLabel(p)) + '</span></div></div>';
    }
    function shipHTML(total) {
      var left = cfg.freeShipping - total;
      return left > 0.005 ? 'Ti mancano ' + eur(Math.round(left * 100) / 100) + ' per la spedizione gratuita' : '';
    }
    function sugRow(s, act, a, b) {
      return '<div class="st-sug">' + (s.v.img ? '<img src="' + esc(s.v.img) + '" alt="" loading="lazy" width="48" height="64">' : '<span class="st-nimg"></span>') +
        '<div class="st-sugtx"><span class="st-brand">' + ROLE_LABEL[s.role] + ' · ' + esc(colorName(s.u)) + '</span><a class="st-title" href="/products/' + esc(s.u.handle) + '?variant=' + esc(s.v.id) + '" target="_blank" rel="noopener">' + esc(s.u.title) + '</a>' +
        '<span class="st-prices">' + priceHTML(s.v) + '</span></div>' +
        '<button class="st-mini" data-act="' + act + '" data-l="' + a + '" data-i="' + b + '" aria-label="Aggiungi: ' + esc(s.u.title) + '">Aggiungi</button></div>';
    }
    function compHTML(l, li) {
      if (!l.sug || !l.sug.length) return '';
      return '<div class="st-comp"><div class="st-complabel">Completa il look</div><div class="st-compgrid">' + l.sug.map(function (s, si) { return sugRow(s, 'complete', li, si); }).join('') + '</div></div>';
    }
    function palDots() {
      var cols = S.col ? [S.col] : (cfg.palettes[S.pal] ? cfg.palettes[S.pal].cols : []);
      return '<span class="st-sw st-swh">' + cols.map(function (c) { return '<i style="' + dotStyle(c) + '"></i>'; }).join('') + '</span>';
    }
    function lookHTML(l, li) {
      return '<article class="st-lk" data-look="' + li + '"><header><h3>Look ' + (li + 1) + '<small>' + esc(l.tpl.name) + ' · ' + l.pcs.length + ' capi</small></h3><span class="st-t">' + eur(l.total) + '</span></header>' +
        '<div class="st-pcs">' + l.pcs.map(function (p, pi) { return pieceHTML(p, li, pi); }).join('') + '</div>' + noteHTML(l) + compHTML(l, li) +
        '<footer><span class="st-fb" id="st-fb' + li + '" role="status" aria-live="polite">' + esc(shipHTML(l.total)) + '</span>' +
        '<button class="st-ghost" data-act="share" data-l="' + li + '">' + ico('share') + 'Copia il link</button>' +
        '<button class="st-cta" data-act="addlook" data-l="' + li + '">Acquista questo look</button></footer></article>';
    }
    function itemHTML(g, i) {
      var it = g.first, u = it.u;
      var others = g.others.slice(0, 4).map(function (o) { return '<i title="' + esc(colorName(o.u)) + '" style="background:' + hexOf(o.u) + '"></i>'; }).join('');
      var sg = GRID ? Engine.gridSuggest(it, CTX) : []; it._sg = sg;
      return '<div class="st-gi"><div class="st-ph">' + (it.v.img ? '<img src="' + esc(it.v.img) + '" alt="' + esc(u.title) + '" loading="lazy" width="240" height="320">' : '') + '</div>' +
        '<div class="st-info"><span class="st-brand">' + esc(u.brand) + '</span><a class="st-title" href="/products/' + esc(u.handle) + '?variant=' + esc(it.v.id) + '" target="_blank" rel="noopener">' + esc(u.title) + '</a>' +
        '<span class="st-meta"><i style="background:' + hexOf(u) + '"></i>' + esc(colorName(u)) + (others ? '<span class="st-alt">' + others + '</span>' : '') + '</span>' +
        '<span class="st-prices">' + priceHTML(it.v) + '</span>' +
        '<span class="st-okk">' + esc(skLabel(it)) + '</span>' +
        '<button class="st-mini" data-act="additem" data-i="' + i + '">Aggiungi</button></div>' +
        (sg.length ? '<div class="st-gsug"><div class="st-complabel">Si abbina con</div>' + sg.map(function (s, si) { return sugRow(s, 'addsug', i, si); }).join('') + '</div>' : '') +
        '</div>';
    }
    var PEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16zM13 7l4 4"/></svg>';
    function pill(txt, aria) { return '<button class="st-tag" data-act="editsz" aria-label="' + esc(aria) + '">' + esc(txt) + PEN + '</button>'; }
    function tagsHTML() {
      var bd = cfg.budgetBands.filter(function (b) { return b.max === S.budget; })[0], bud = bd ? bd.l : 'Nessun limite', t = [];
      sizeKeysOf(S).forEach(function (k) {
        var roles = rolesOfKey(k), lbl = roles.map(function (r) { return PIECE_TXT[r]; }).join(' e ');
        t.push(pill(lbl + ' ' + S.sz[k].map(function (z) { return (!NUM_KEYS[k] && LET[z]) ? LET[z] : sizeTxt(z, k); }).filter(function (z, i, a) { return a.indexOf(z) === i; }).join(' / '), 'Cambia la taglia: ' + lbl));
      });
      return t.join('') + pill(bud, 'Cambia il budget');
    }
    function brandChips() {
      var c = {}; DATA.units.forEach(function (u) { c[u.brandKey] = (c[u.brandKey] || { n: 0, name: u.brand }); c[u.brandKey].n++; });
      var list = Object.keys(c).filter(function (k) { return c[k].n >= cfg.minBrandCount; }).sort();
      if (S.brand !== '*' && list.indexOf(S.brand) < 0 && c[S.brand]) list.push(S.brand);
      if (list.length < 2) return '';
      return '<button class="st-fchip" data-act="brand" data-v="*" aria-pressed="' + (S.brand === '*') + '">Tutti i brand</button>' +
        list.map(function (k) { return '<button class="st-fchip" data-act="brand" data-v="' + k + '" aria-pressed="' + (S.brand === k) + '">' + esc(c[k].name) + '</button>'; }).join('');
    }
    function rail(inner) {
      var a = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M';
      return '<div class="st-rail"><button class="st-rb st-rl" data-act="rail" data-d="-1" aria-label="Scorri a sinistra" hidden>' + a + '15 6l-6 6 6 6"/></svg></button>' + inner +
        '<button class="st-rb st-rr" data-act="rail" data-d="1" aria-label="Scorri a destra" hidden>' + a + '9 6l6 6-6 6"/></svg></button></div>';
    }
    function updateRails() {
      document.querySelectorAll('.st-rail').forEach(function (r) {
        var bar = r.querySelector('.st-bar2'), l = r.querySelector('.st-rl'), n = r.querySelector('.st-rr'); if (!bar) return;
        l.hidden = bar.scrollLeft < 4; n.hidden = bar.scrollLeft + bar.clientWidth >= bar.scrollWidth - 4;
      });
    }
    host.addEventListener('scroll', updateRails, true);
    window.addEventListener('resize', updateRails);
    function viewResult(fade) {
      GRID = Engine.isGridMode(S.pieces);
      var who = S.auto ? 'Scelta da ' + NAME + ': ' : '';
      $.innerHTML = '<div class="st-top st-rtop"><button class="st-back" data-act="again" aria-label="Nuova ricerca"><svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/></svg></button>' +
        '<span class="st-rtitle">' + (GRID ? 'I capi per te' : 'I tuoi look') + '</span>' + (xBtn() || '<span class="st-xsp"></span>') + '</div>' +
        '<section class="' + (fade ? 'st-fade ' : '') + 'st-res"><div class="st-rhead"><div class="st-kicker" id="st-kick">' + (GRID ? 'I capi per te' : 'I tuoi look') + '</div>' +
        '<h2>' + esc(occLabel[S.occ]) + ', <em>' + esc(who + colorTitle().toLowerCase()) + '</em>' + palDots() + '</h2>' +
        '<div class="st-tags">' + tagsHTML() + '</div><p class="st-taghelp">Tocca una voce per cambiarla.</p>' +
        (GRID ? '' : '<button class="st-fchip st-sh" data-act="shuffle">' + ico('swap') + 'Rimescola i look</button>') + '</div>' +
        (GRID ? '' : '<div class="st-looks" id="st-looks"></div><div class="st-sec"><h3>Tutti i capi per te</h3><span id="st-cnt2"></span></div>') +
        rail('<div class="st-bar2" id="st-cats"></div>') + '<div class="st-grid" id="st-grid"></div><button class="st-more" id="st-more" data-act="more" hidden>Mostra altri</button>' +
        '<button class="st-again" data-act="again">Nuova ricerca</button><div id="st-debug"></div></section>' +
        '<div class="st-dock" id="st-dock" hidden><div class="st-din"><div class="st-tot"><small id="st-dlabel">Look 1</small><strong id="st-dtot"></strong></div>' +
        '<button class="st-cta" data-act="dockadd">Acquista questo look</button><p class="st-dship" id="st-dship"></p></div></div>';
      drawResults();
      updateRails();
    }
    function selOf() {
      return { occ: S.occ, col: S.col, pal: S.pal, pieces: S.pieces, sizes: S.sz, budget: S.budget, brand: S.brand };
    }
    function drawResults() {
      var sel = selOf();
      if (!S.seed) { S.seed = Math.floor(Math.random() * 900000) + 100; syncURL(); }
      var A = Engine.allItems(DATA.units, sel, cfg);
      ALL = A.items;
      if (!GRID) {
        var r = Engine.buildLooks(DATA.units, sel, cfg, S.seed);
        LOOKS = r.looks; CTX = r.ctx;
        var lk = document.getElementById('st-looks');
        lk.innerHTML = LOOKS.length ? LOOKS.map(lookHTML).join('') : emptyHTML(sel);
        document.getElementById('st-kick').textContent = LOOKS.length === 1 ? '1 look per te' : LOOKS.length ? LOOKS.length + ' look per te' : 'I capi per te';
        document.getElementById('st-cnt2').textContent = ALL.length + (ALL.length === 1 ? ' capo' : ' capi');
      } else {
        LOOKS = []; CTX = A.ctx;
        document.getElementById('st-kick').textContent = ALL.length + (ALL.length === 1 ? ' capo per te' : ' capi per te');
      }
      drawGrid();
      observeLooks();
      if (S.debug) drawDebug();
      emit('result', { looks: LOOKS.length, items: ALL.length, grid: GRID, candidates: DATA.units.length, seed: S.seed, occ: S.occ,
        color: S.col, palette: S.pal != null && cfg.palettes[S.pal] ? cfg.palettes[S.pal].name : null, auto: !!S.auto,
        pieces: S.pieces, sizes: S.sz, budget: S.budget });
    }
    function drawGrid() {
      var counts = {}; ALL.forEach(function (g) { counts[g.first.role] = (counts[g.first.role] || 0) + 1; });
      var roles = Object.keys(counts);
      if (CAT !== 'all' && !counts[CAT]) CAT = 'all';
      VIS = CAT === 'all' ? ALL : ALL.filter(function (g) { return g.first.role === CAT; });
      document.getElementById('st-cats').innerHTML = roles.length > 1 ?
        '<button class="st-fchip" data-act="cat" data-v="all" aria-pressed="' + (CAT === 'all') + '">Tutti</button>' +
        roles.map(function (r) { return '<button class="st-fchip" data-act="cat" data-v="' + r + '" aria-pressed="' + (CAT === r) + '">' + CAT_LABEL[r] + ' (' + counts[r] + ')</button>'; }).join('') : '';
      var g = document.getElementById('st-grid');
      g.className = 'st-grid' + (GRID ? ' st-grid1' : '');
      g.innerHTML = VIS.slice(0, SHOWN).map(itemHTML).join('') || emptyGridHTML();
      document.getElementById('st-more').hidden = VIS.length <= SHOWN;
      updateRails();
    }
    function emptyGridHTML() {
      return '<div class="st-empty"><p><b>Nessun capo disponibile con queste scelte.</b></p><p>Prova un’altra taglia, un budget più alto o un altro colore.</p></div>';
    }
    /* nessun look: si dice cosa manca, capo per capo, con il pulsante per cambiare proprio quello */
    function sizeList(role, keys) {
      var nums = keys.filter(function (k) { return /^\d+$/.test(k); }).sort(function (a, b) { return a - b; }), out = [];
      if (keys.indexOf('TU') >= 0) out.push('taglia unica');
      nums.forEach(function (k) { var t = (LETTER_KEYS[role] && LET[k]) ? LET[k] : k; if (out.indexOf(t) < 0) out.push(t); });
      return out.length > 1 ? out.slice(0, -1).join(', ') + ' e ' + out[out.length - 1] : out.join('');
    }
    function chosenSize(role) {
      var k = SZ_KEY[role], z = (S.sz[k] || [])[0]; if (!z) return '';
      return z === 'TU' ? 'taglia unica' : (role === 'scarpe' ? 'numero ' + z : 'taglia ' + ((!NUM_KEYS[k] && LET[z]) ? LET[z] : z));
    }
    function actBtn(act, v, label) { return '<button class="st-fchip" data-act="' + act + '"' + (v != null ? ' data-v="' + v + '"' : '') + '>' + esc(label) + '</button>'; }
    function emptyHTML(sel) {
      var d = Engine.diagnose(DATA.units, sel, cfg), rows = [], colTxt = S.col ? famLabel[S.col].toLowerCase() : 'della palette «' + colorTitle() + '»';
      var extra = function (r) { return Engine.EXTRA_PIECES.indexOf(r) >= 0 && Engine.hasLook(S.pieces.filter(function (x) { return x !== r; })); };
      d.roles.forEach(function (x) {
        var nm = PIECE_TXT[x.role], pl = CAT_LABEL[x.role].toLowerCase(), txt, btns = [];
        if (x.cause === 'occasione') { txt = 'Per ' + occLabel[S.occ].toLowerCase() + ' al momento non abbiamo ' + pl + '.'; btns.push(extra(x.role) ? actBtn('drop', x.role, 'Togli ' + nm.toLowerCase()) : actBtn('goto', 'cap', 'Cambia i capi')); }
        else if (x.cause === 'colore') { txt = 'Non abbiamo ' + pl + ' nei colori ' + (S.col ? 'che si abbinano al ' + colTxt : colTxt) + '.'; btns.push(actBtn('goto', 'col', 'Cambia colore')); if (extra(x.role)) btns.push(actBtn('drop', x.role, 'Togli ' + nm.toLowerCase())); }
        else if (x.cause === 'taglia') { txt = nm + ': nei tuoi colori c’è ' + (x.sizes.length ? 'in ' + sizeList(x.role, x.sizes) : 'solo in taglie non disponibili') + ', non in ' + chosenSize(x.role) + '.'; btns.push(actBtn('goto', 'tg', 'Cambia taglia')); btns.push(actBtn('goto', 'col', 'Cambia colore')); }
        else { txt = nm + ' nella tua taglia parte da ' + eur(x.minPrice) + ', oltre il budget scelto.'; btns.push(actBtn('budget0', null, 'Nessun limite di budget')); }
        rows.push('<li><p>' + esc(txt) + '</p><div class="st-hints">' + btns.join('') + '</div></li>');
      });
      if (d.global) {
        var g = d.global, gt, gb = [];
        if (g.cause === 'protagonista') { var pn = g.roles.map(function (r) { return PIECE_TXT[r].toLowerCase(); }), pj = pn.length > 1 ? pn.slice(0, -1).join(', ') + ' o ' + pn[pn.length - 1] : pn.join('');
          gt = 'Nella tua taglia non troviamo ' + pj + ' ' + colTxt + ': il colore che scegli deve stare su almeno uno di questi capi.'; gb = [actBtn('goto', 'tg', 'Cambia taglia'), actBtn('goto', 'col', 'Cambia colore')]; }
        else if (g.cause === 'budget') {
          var names = S.pieces.map(function (r) { return PIECE_TXT[r].toLowerCase(); });
          var lst = names.length > 1 ? names.slice(0, -1).join(', ') + ' e ' + names[names.length - 1] : names.join('');
          gt = 'Ogni capo rientra nel budget, ma ' + lst + ' insieme partono da ' + eur(g.minTotal) + ': oltre i ' + eur(S.budget) + ' scelti.';
          var up = cfg.budgetBands.filter(function (b) { return b.max > S.budget && b.max >= g.minTotal; })[0];
          gb = (g.drops || []).map(function (x) { return actBtn('drop', x, 'Togli ' + PIECE_TXT[x].toLowerCase()); });
          gb.push(up ? actBtn('budset', up.max, 'Budget ' + up.l.charAt(0).toLowerCase() + up.l.slice(1)) : actBtn('budget0', null, 'Nessun limite di budget'));
        }
        else { gt = 'I capi disponibili nella tua taglia non si abbinano bene tra loro con questi colori.'; gb = [actBtn('goto', 'col', 'Cambia colore')]; }
        rows.push('<li><p>' + esc(gt) + '</p><div class="st-hints">' + gb.join('') + '</div></li>');
      }
      var hs = Engine.hints(DATA.units, sel, cfg).filter(function (h) { return h.patch.pal !== undefined; }).slice(0, 2);
      return '<div class="st-empty st-diag"><p><b>Nessun look con queste scelte. Ecco cosa manca:</b></p><ul class="st-dlist">' + rows.join('') + '</ul>' +
        (hs.length ? '<p class="st-dalt">Oppure prova una palette che oggi ha look pronti:</p><div class="st-hints">' + hs.map(function (h) {
          return '<button class="st-fchip" data-act="hintpal" data-v="' + h.patch.pal + '">' + esc(cfg.palettes[h.patch.pal].name) + ' — ' + h.looks + ' look</button>';
        }).join('') + '</div>' : '') + '</div>';
    }

    /* dock: mostra il totale del look più visibile */
    var io = null, vis = {}, dockLook = 0;
    function observeLooks() {
      if (io) io.disconnect();
      vis = {};
      if (!('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { vis[e.target.getAttribute('data-look')] = e.isIntersecting ? e.intersectionRatio : 0; });
        updateDock();
      }, { threshold: [0, .1, .25, .5, .75, 1] });
      document.querySelectorAll('.st-lk').forEach(function (n) { io.observe(n); });
    }
    function updateDock() {
      var dock = document.getElementById('st-dock'); if (!dock) return;
      var best = -1, bi = -1;
      Object.keys(vis).forEach(function (k) { if (vis[k] > best) { best = vis[k]; bi = +k; } });
      if (bi < 0 || best <= 0 || !LOOKS[bi]) { dock.hidden = true; return; }
      dockLook = bi; dock.hidden = false;
      document.getElementById('st-dlabel').textContent = 'Look ' + (bi + 1) + ' · ' + LOOKS[bi].pcs.length + ' capi';
      document.getElementById('st-dtot').textContent = eur(LOOKS[bi].total);
      document.getElementById('st-dship').textContent = shipHTML(LOOKS[bi].total);
    }

    /* ---------- debug (?debug=1, solo tema di prova) ---------- */
    function drawDebug() {
      var by = {}; DATA.excluded.forEach(function (x) { var k = x.reason.replace(/\(.*?\)/g, '').trim(); by[k] = (by[k] || 0) + 1; });
      var rows = DATA.excluded.slice(0, 400).map(function (x) { return '<tr><td>' + esc(x.title) + '</td><td>' + esc(x.brand) + '</td><td>' + esc(x.reason) + '</td></tr>'; }).join('');
      var fc = Engine.familyCounts(DATA.units);
      document.getElementById('st-debug').innerHTML = '<details class="st-dbg" open><summary>Debug — ' + DATA.units.length + ' unità usabili su ' + (DATA.total || '?') + ' prodotti caricati, ' + DATA.excluded.length + ' esclusioni</summary>' +
        '<p>Capi per colore: ' + esc(Object.keys(fc).map(function (k) { return (famLabel[k] || k) + ' ' + fc[k]; }).join(' · ')) + '</p>' +
        '<ul>' + Object.keys(by).sort().map(function (k) { return '<li>' + esc(k) + ': <b>' + by[k] + '</b></li>'; }).join('') + '</ul>' +
        '<table><thead><tr><th>Prodotto</th><th>Brand</th><th>Motivo</th></tr></thead><tbody>' + rows + '</tbody></table></details>';
    }

    /* ---------- carrello ---------- */
    function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
    function checkAvail(gids) {
      return gql('query($ids:[ID!]!){nodes(ids:$ids){...on ProductVariant{id availableForSale}}}', { ids: gids }).then(function (res) {
        var bad = {}; ((res.data && res.data.nodes) || []).forEach(function (n) { if (n && !n.availableForSale) bad[n.id] = 1; });
        return bad;
      }).catch(function () { return {}; });
    }
    /* capi dello stesso ruolo, nei colori e nella taglia scelti, che starebbero nel look solo alzando il budget */
    function overNote(l, pi) {
      if (!S.budget) return null;
      var ctx0 = Engine.makeCtx(DATA.units, { occ: S.occ, col: S.col, pal: S.pal, pieces: S.pieces, sizes: S.sz, budget: 0, brand: S.brand }, cfg);
      var inBud = {}; Engine.alternatives(l, pi, CTX).forEach(function (e) { inBud[e.u.uid] = 1; });
      var others = l.pcs.reduce(function (a, p, k) { return k === pi ? a : a + p.v.price; }, 0), min = null, n = 0;
      Engine.alternatives(l, pi, ctx0).forEach(function (e) {
        if (inBud[e.u.uid]) return;
        n++; var t = others + e.v.price; if (min === null || t < min) min = t;
      });
      if (!n) return null;
      var up = cfg.budgetBands.filter(function (bd) { return bd.max > S.budget && bd.max >= min; })[0] || { max: 0, l: '' };
      return { role: l.pcs[pi].role, n: n, up: up };
    }
    function noteHTML(l) {
      var n = l.note; if (!n) return '';
      var cat = n.n === 1 ? PIECE_TXT[n.role].toLowerCase() : CAT_LABEL[n.role].toLowerCase();
      var btn = n.up.max ? 'Passa a ' + n.up.l : 'Togli il limite di budget';
      var fem = /^(gonna|scarpe|borsa)$/.test(n.role);
      return '<div class="st-lnote" role="status"><p><b>Hai visto ' + (fem ? 'tutte le ' : 'tutti i ') + esc(CAT_LABEL[n.role].toLowerCase()) + ' nel budget.</b><br>' +
        (n.n === 1 ? (fem ? 'Un’altra' : 'Un altro') : (fem ? 'Altre ' : 'Altri ') + n.n) + ' con i tuoi colori e la tua taglia ' + (n.n === 1 ? 'supera' : 'superano') + ' i ' + esc(eur(S.budget)) + '.</p>' +
        '<button class="st-fchip" data-act="' + (n.up.max ? 'budset' : 'budget0') + '"' + (n.up.max ? ' data-v="' + n.up.max + '"' : '') + '>' + esc(btn) + '</button></div>';
    }
    function redrawLook(li) {
      var art = document.querySelector('.st-lk[data-look="' + li + '"]');
      if (art) { art.outerHTML = lookHTML(LOOKS[li], li); observeLooks(); }
    }
    function substitute(li, bad) {
      var l = LOOKS[li], changed = 0;
      for (var i = 0; i < l.pcs.length; i++) {
        if (!bad[l.pcs[i].v.gid]) continue;
        var alts = Engine.alternatives(l, i, CTX, bad);
        if (alts.length) { l.pcs[i] = { role: l.pcs[i].role, u: alts[0].u, v: alts[0].v, sk: alts[0].sk }; changed++; }
        else { l.pcs.splice(i, 1); i--; changed++; }
      }
      l.total = l.pcs.reduce(function (a, p) { return a + p.v.price; }, 0);
      l.sug = Engine.suggestions(l, CTX);
      redrawLook(li);
      return changed;
    }
    function postCart(items) {
      var cart = cartEl(), body = { items: items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); });
    }
    function afterAdd(state) {
      var cart = cartEl();
      /* a schermo intero il popup di notifica di Dawn resterebbe sotto lo stylist: si va al carrello */
      if (FULL && (!cart || cart.tagName.toLowerCase() !== 'cart-drawer')) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      try {
        if (cart && cart.renderContents && state.sections) { cart.renderContents(state); return; }
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'stylist', cartData: state });
      } catch (e) { console.warn('[stylist] drawer', e); }
      if (!cart) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    function fb(li, msg) { var el = document.getElementById('st-fb' + li); if (el) el.textContent = msg; if (/aggiunto|copiato/i.test(msg || '')) toast(/aggiunto/i.test(msg) ? 'Look aggiunto al carrello' : 'Link copiato'); }
    var busy = false;
    function addLook(li, btn) {
      var l = LOOKS[li]; if (!l || busy) return;
      busy = true; if (btn) { btn.disabled = true; btn.dataset.txt = btn.textContent; btn.textContent = 'Un attimo…'; }
      var done = function () { busy = false; document.querySelectorAll('[data-act="addlook"],[data-act="dockadd"]').forEach(function (b) { b.disabled = false; if (b.dataset.txt) b.textContent = b.dataset.txt; }); };
      checkAvail(l.pcs.map(function (p) { return p.v.gid; })).then(function (bad) {
        if (Object.keys(bad).length) { var n = substitute(li, bad); done(); fb(li, n ? 'Un capo è terminato, ne abbiamo scelto un altro. Controlla il look e riprova.' : ''); emit('swap', { reason: 'esaurito' }); return; }
        var items = l.pcs.map(function (p) { return { id: parseInt(p.v.id, 10), quantity: 1, properties: { _stylist_look: l.id } }; });
        return postCart(items).then(function (res) {
          if (res.ok) {
            emit('add_look', { look: l.id, items: l.pcs.length, value: l.total });
            afterAdd(res.json); done(); fb(li, 'Look aggiunto al carrello.');
          } else if (res.status === 422) {
            return checkAvail(l.pcs.map(function (p) { return p.v.gid; })).then(function (bad2) {
              var n = substitute(li, bad2); done();
              fb(li, n ? 'Un capo è terminato, ne abbiamo scelto un altro. Controlla il look e riprova.' : ((res.json && res.json.description) || 'Non è stato possibile aggiungere il look.'));
            });
          } else { done(); fb(li, (res.json && (res.json.description || res.json.message)) || 'Non è stato possibile aggiungere il look.'); }
        });
      }).catch(function (e) { console.error('[stylist]', e); done(); fb(li, 'Qualcosa non ha funzionato. Riprova.'); });
    }
    function addVariant(v, btn, props, evt) {
      if (busy) return; busy = true; btn.disabled = true;
      checkAvail([v.gid]).then(function (bad) {
        if (bad[v.gid]) { busy = false; btn.textContent = 'Esaurito'; return; }
        return postCart([{ id: parseInt(v.id, 10), quantity: 1, properties: props }]).then(function (res) {
          busy = false; btn.disabled = false;
          if (res.ok) { emit(evt, { id: v.id, value: v.price }); afterAdd(res.json); btn.textContent = 'Aggiunto ✓'; setTimeout(function () { btn.textContent = 'Aggiungi'; }, 2500); }
          else btn.textContent = 'Non disponibile';
        });
      }).catch(function () { busy = false; btn.disabled = false; });
    }

    /* ---------- azioni ---------- */
    function goBack() {
      if (history.state && history.state.st && history.length > 1) { history.back(); return; }
      var s = stepOf(S);
      if (s === 4) S.edit = 'tg'; else if (s === 3) S.edit = 'cap'; else if (s === 2) S.edit = 'col'; else if (s === 1) S.edit = 'occ'; else if (s === 0) { closeApp(); return; }
      S.seed = null; nav(true);
    }
    function setColor(col, pal, auto) {
      S.col = col; S.pal = pal; S.auto = !!auto; S.seed = null;
      document.querySelectorAll('.st-col').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-v') === S.col); });
      document.querySelectorAll('.st-pal').forEach(function (x) { x.setAttribute('aria-pressed', !S.auto && S.pal === +x.getAttribute('data-v')); });
      var au = document.querySelector('.st-auto'); if (au) au.setAttribute('aria-pressed', S.auto);
      updateCount();
    }
    /* colore: una sola scelta, si passa da soli al passaggio dopo (come le domande del Gustometro) */
    function colDone() {
      emit('step', { n: 2, color: S.col, palette: S.pal != null ? cfg.palettes[S.pal].name : null, auto: !!S.auto });
      S.edit = 'cap'; setTimeout(function () { nav(); }, 180);       // il passaggio Capi resta fermo finché non premi Continua
    }
    host.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || !host.contains(b)) return;
      var act = b.getAttribute('data-act'), v = b.getAttribute('data-v');
      switch (act) {
        case 'rail': { var rb = b.closest('.st-rail').querySelector('.st-bar2'); rb.scrollBy({ left: (+b.getAttribute('data-d')) * Math.max(160, rb.clientWidth * .7), behavior: 'smooth' }); break; }
        case 'forget': Mem.clear(); render(); break;
        case 'back': goBack(); break;
        case 'occ':
          b.setAttribute('aria-pressed', 'true'); S.occ = v; S.edit = null; S.seed = null; emit('step', { n: 1, v: v });
          setTimeout(function () { nav(); }, 160); break;
        case 'col': setColor(v, null, false); colDone(); break;
        case 'pal': setColor(null, +v, false); colDone(); break;
        case 'auto': pickAuto(); setColor(null, S.pal, true); colDone(); break;
        case 'colnext':
          if (!hasColor(S)) break;
          emit('step', { n: 2, color: S.col, palette: S.pal != null ? cfg.palettes[S.pal].name : null, auto: !!S.auto }); S.edit = 'cap'; nav(); break;
        case 'piece': {
          if (b.getAttribute('aria-disabled') === 'true') {
            var pm = document.getElementById('st-pmsg'); if (pm) { pm.textContent = 'Al momento pochi capi di questo tipo nei colori scelti.'; pm.hidden = false; }
            emit('unavailable_piece', { piece: v }); break;
          }
          /* pantalone e gonna si escludono; l'abito esclude top, pantalone e gonna: la scelta nuova sostituisce la vecchia */
          S.pieces = S.pieces.indexOf(v) >= 0 ? S.pieces.filter(function (x) { return x !== v; }) : Engine.compatible(S.pieces, v);
          document.querySelectorAll('[data-act="piece"]').forEach(function (x) { x.setAttribute('aria-pressed', S.pieces.indexOf(x.getAttribute('data-v')) >= 0); });
          var nx = document.getElementById('st-next'); if (nx) nx.disabled = !Engine.hasLook(S.pieces);
          var pd = document.getElementById('st-pdesc'); if (pd) pd.textContent = piecesDesc();
          syncURL(); break; }
        case 'pnext':
          if (!Engine.hasLook(S.pieces)) break;
          var need = sizeKeysOf(S); Object.keys(S.sz).forEach(function (k) { if (need.indexOf(k) < 0) S.sz[k] = []; });
          prefill(); S.edit = 'tg'; S.seed = null;
          emit('step', { n: 3, pieces: S.pieces }); nav(); break;
        case 'psize': {
          /* una sola taglia per capo: la nuova scelta sostituisce la precedente */
          var k = b.getAttribute('data-k'), arr = S.sz[k] || [], gk = v.split(',');
          var allOn = gk.every(function (x) { return arr.indexOf(x) >= 0; }) && arr.length === gk.length;
          S.sz[k] = allOn ? [] : gk.slice();
          document.querySelectorAll('[data-act="psize"][data-k="' + k + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b && !allOn); });
          refreshBud();
          syncURL(); break; }
        case 'budget':
          S.budget = parseInt(v, 10); S.seed = null;
          document.querySelectorAll('[data-act="budget"]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-v') === v); });
          var nx3 = document.getElementById('st-next'); if (nx3) nx3.disabled = !ready4();
          syncURL(); break;
        case 'show':
          if (!ready4()) break;
          S.edit = null; S.seed = null;
          Mem.add({ occ: S.occ, col: S.col, pal: S.pal, pieces: S.pieces, sz: S.sz, d: new Date().toISOString().slice(0, 10) });
          emit('step', { n: 4, sizes: S.sz, budget: S.budget }); nav(); toTop(); break;
        case 'retry': DATA.status = 'idle'; ensureData(); render(); break;
        case 'edit': S.edit = 'cap'; S.seed = null; nav(); break;
        case 'editsz': S.edit = 'tg'; S.seed = null; emit('edit', { from: 'pill' }); nav(); break;
        case 'goto': S.edit = v; S.seed = null; emit('edit', { from: 'side', step: v }); nav(); break;
        case 'close': closeApp(); break;
        case 'again': S = { occ: null, col: null, pal: null, auto: false, pieces: [], sz: emptySz(), budget: null, seed: null, brand: '*', go: true, edit: null, debug: S.debug }; CAT = 'all'; nav(); toTop(); break;
        case 'shuffle': S.seed = Math.floor(Math.random() * 900000) + 100; SHOWN = 8; emit('shuffle', {}); syncURL(); drawResults(); break;
        case 'brand': S.brand = v; emit('filter', { brand: v }); nav(true); break;
        case 'cat': CAT = v; SHOWN = 8; drawGrid(); break;
        case 'more': SHOWN += 8; drawGrid(); break;
        case 'drop': S.pieces = S.pieces.filter(function (x) { return x !== v; }); S.seed = null; nav(true); break;
        case 'budget0': S.budget = 0; S.seed = null; nav(true); break;
        case 'budset': S.budget = parseInt(v, 10) || 0; S.seed = null; nav(true); break;
        case 'hintpal': S.pal = +v; S.col = null; S.auto = false; S.seed = null; nav(true); break;
        case 'hint': {
          var h = Engine.hints(DATA.units, selOf(), cfg)[+b.getAttribute('data-i')];
          if (h) {
            if (h.patch.budget !== undefined) S.budget = h.patch.budget;
            if (h.patch.drop) S.pieces = S.pieces.filter(function (x) { return x !== h.patch.drop; });
            if (h.patch.pal !== undefined) { S.pal = h.patch.pal; S.col = null; S.auto = false; }
            S.seed = null; nav(true);
          }
          break; }
        case 'swap': {
          /* giro completo: ogni alternativa entro il budget una volta sola; a fine giro si dice
             quanti altri capi con gli stessi colori e taglia ci sarebbero alzando il budget */
          var li = +b.getAttribute('data-l'), pi = +b.getAttribute('data-p'), l = LOOKS[li], key = l.pcs[pi].role;
          l.seen = l.seen || {}; var seen = l.seen[key] = l.seen[key] || {};
          seen[l.pcs[pi].v.gid] = 1;
          var alts = Engine.alternatives(l, pi, CTX, seen), note = null;
          if (!alts.length) {
            note = overNote(l, pi);
            l.seen[key] = {}; l.seen[key][l.pcs[pi].v.gid] = 1;
            alts = Engine.alternatives(l, pi, CTX, l.seen[key]);
            if (!alts.length && !note) { l.note = null; redrawLook(li); fb(li, 'Per questo capo non ci sono altre alternative con le tue scelte.'); break; }
          }
          l.note = note;
          if (alts.length) {
            l.pcs[pi] = { role: key, u: alts[0].u, v: alts[0].v, sk: alts[0].sk };
            l.total = l.pcs.reduce(function (a, p) { return a + p.v.price; }, 0);
            l.id = Engine.lookId(l, { occ: S.occ, seed: S.seed });
            l.sug = Engine.suggestions(l, CTX);
            emit('swap', { role: key });
          }
          if (note) { emit('swap_end', { role: key, over: note.n }); toast('Altri ' + note.n + ' capi oltre il budget: guarda sotto il look'); }
          redrawLook(li);
          var again = document.querySelector('.st-lk[data-look="' + li + '"] .st-swap[data-p="' + pi + '"]'); if (again) again.focus();
          break; }
        case 'complete': {
          var cl = +b.getAttribute('data-l'), lk = LOOKS[cl], sg = lk && lk.sug[+b.getAttribute('data-i')];
          if (!sg) break;
          lk.pcs.push({ role: sg.role, u: sg.u, v: sg.v, sk: sg.sk });
          lk.total = lk.pcs.reduce(function (a, p) { return a + p.v.price; }, 0);
          lk.id = Engine.lookId(lk, { occ: S.occ, seed: S.seed });
          lk.sug = Engine.suggestions(lk, CTX);
          emit('complete', { role: sg.role, look: lk.id, value: lk.total });
          redrawLook(cl); updateDock(); break; }
        case 'addlook': addLook(+b.getAttribute('data-l'), b); break;
        case 'dockadd': addLook(dockLook, b); break;
        case 'additem': { var g = VIS[+b.getAttribute('data-i')]; if (g) addVariant(g.first.v, b, { _stylist_item: '1' }, 'add_item'); break; }
        case 'addsug': {
          var g2 = VIS[+b.getAttribute('data-l')], s2 = g2 && g2.first._sg && g2.first._sg[+b.getAttribute('data-i')];
          if (s2) addVariant(s2.v, b, { _stylist_item: '1' }, 'complete'); break; }
        case 'share': {
          var url = location.origin + buildQuery(S), li2 = +b.getAttribute('data-l');
          var okMsg = function () { fb(li2, 'Link copiato: chi lo apre vede gli stessi look.'); emit('share', { look: LOOKS[li2] && LOOKS[li2].id }); };
          if (navigator.share) navigator.share({ url: url, title: document.title }).then(okMsg).catch(function () { });
          else if (navigator.clipboard) navigator.clipboard.writeText(url).then(okMsg).catch(function () { fb(li2, url); });
          else fb(li2, url);
          break; }
      }
    });

    /* ---------- render ---------- */
    var lastStep = null;
    function render() {
      var st = stepOf(S), fade = st !== lastStep;
      setFull(st >= 0);
      if (S.occ) ensureData();
      if (fade) { toTop(); lastStep = st; }
      drawSide(st);
      if (st === 0) return viewOcc();
      if (DATA.status === 'error') return viewError();
      if (st === 1) return viewCol();
      if (st === 2) return viewPieces(fade);
      if (st === 3) return viewSizes(fade);
      if (DATA.status === 'loading' || DATA.status === 'idle') return viewLoading();
      SHOWN = 8; viewResult(fade);
    }
    emit('start', {});
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : globalThis);
